import React, { useState, useEffect, useRef } from 'react'
import withRouter from 'with-router';
import { styled, useTheme } from '@mui/material/styles';
import { bindActionCreators } from 'redux';
import { connect, useDispatch, useSelector } from 'react-redux';
import Divider from '@mui/material/Divider';
import Paper from '@mui/material/Paper';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import FormLabel from '@mui/material/FormLabel';
import ButtonGroup from '@mui/material/ButtonGroup';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import CircularProgress from '@mui/material/CircularProgress';
import LinearProgress from '@mui/material/LinearProgress';
import Slide from '@mui/material/Slide';
import Collapse from '@mui/material/Collapse';
import Check from '@mui/icons-material/Check';
import DoneOutlined from '@mui/icons-material/DoneOutlined';
import CloseIcon from '@mui/icons-material/Close';
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import DynamicFeedIcon from '@mui/icons-material/DynamicFeed';
import HorizontalSplitIcon from '@mui/icons-material/HorizontalSplit';
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';
import LayersIcon from '@mui/icons-material/Layers';
import TranslateOutlinedIcon from '@mui/icons-material/TranslateOutlined';
import IsoRoundedIcon from '@mui/icons-material/IsoRounded';
import PlusOneRoundedIcon from '@mui/icons-material/PlusOneRounded';
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import AvTimerOutlinedIcon from '@mui/icons-material/AvTimerOutlined';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepContent from '@mui/material/StepContent';
import Tooltip from '@mui/material/Tooltip';
import Fade from '@mui/material/Fade';
import ClickAwayListener from '@mui/material/ClickAwayListener';

import Input from '@mui/material/Input';
import Badge from '@mui/material/Badge';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormHelperText from '@mui/material/FormHelperText';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import Chip from '@mui/material/Chip';
import SyncIcon from '@mui/icons-material/Sync';
import PlaylistPlayOutlinedIcon from '@mui/icons-material/PlaylistPlayOutlined';
import PlusOneOutlinedIcon from '@mui/icons-material/PlusOneOutlined';
import Filter9PlusOutlinedIcon from '@mui/icons-material/Filter9PlusOutlined';
import GTranslateOutlinedIcon from '@mui/icons-material/GTranslateOutlined';
import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';
import HorizontalSplitRoundedIcon from '@mui/icons-material/HorizontalSplitRounded';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

import PropTypes from 'prop-types';
import { SimpleTreeView as TreeView } from '@mui/x-tree-view/SimpleTreeView';
import { TreeItem } from '@mui/x-tree-view/TreeItem';
//import { useSpring, animated, useResize } from '@react-spring/web'; // web.cjs is required for IE 11 support
import html2canvas from 'html2canvas';

import FadingTextComponent from './FadingTextComponent';
import RechargePlans from './RechargePlans';
import { clearCurrentBulkTask } from './SnackbarItems';
import LoadingIndicator from './LoadingIndicator';
import bulkTranslation, { bulkCountWords, bulkTranslationStart, bulkTranslateDirect, bulkTranslationGetTasks, bulkTranslationClearTasks, prepareCountWords, bulkTranslationRewind, bulkTranslationResetRun, bulkTranslationSetSynchronizing, bulkTranslationSectionSynchronized } from '../modules/bulkTranslation.js';

// task states the queue ends a run with that is not a completed one (its status field; the
// task_status sub-fields lag behind and are not looked at)
const ABORTED_TASK_STATES = ['cancelled', 'canceled', 'failed', 'error'];
import { syncProducts, resyncProducts } from '../modules/products';
import { syncCollections } from '../modules/collections';
import { syncPages } from '../modules/pages';
import { syncNavigation } from '../modules/navigation';
import { syncBlogs } from '../modules/blogs';
import { syncArticles } from '../modules/articles';
import { getTranslationProgress } from '../modules/stats';
import { getBulkSettings, resolveBulkTranslationType, hasBulkTranslationAccess } from '../modules/config.js';
import API from '../api/api';
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';
import { Typography, Link } from '@mui/material';
import { CONSOLE_LEVELS } from '@sentry/utils';
import _ from 'lodash';
import { Trans, withTranslation, useTranslation } from 'react-i18next';
import { PlusOneOutlined } from '@mui/icons-material';
import { UpgradePlanHint } from './PricingPlans.js';


export const taskKey2DataObject = (key) => {
  let split1 = key.split(':');
  let split2 = split1[2].split('_')
  return {
    store: split1[1],
    to: split2[0],
    scope: split2[1].toLowerCase(),
    type: split2[2].toLowerCase(),
  };
}

// Selectable top level sections of the field tree, in the order they are rendered, plus
// the sub-fields that hang off them.
const BULK_SECTIONS = ['products', 'collections', 'pages', 'navigation', 'blogs', 'articles'];

// Stepper indices. One configuration step holds languages and contents; the run step is the
// count in the classic flow and start + progress in the AI flow; the translate step is classic only
const STEP_CONFIG = 0;
const STEP_RUN = 1;
const STEP_TRANSLATE = 2;
const BULK_SUB_FIELDS = ['products.variants', 'products.options'];
// the summary lists the product sub-fields as entries of their own; "bulkTranslationFeature.
// settingsDialog.products.variants" resolves to nothing, so the id itself would be the label
export const BULK_SUB_FIELD_LABELS = {
  'products.variants': 'bulkTranslationFeature.settingsDialog.variants',
  'products.options': 'bulkTranslationFeature.settingsDialog.options',
};

// Shared helper: derive the sections that have to be re-synced after a bulk translation.
// A translate task key carries ALL scopes of that run as a comma separated list
// (e.g. "products,collections,pages"), so it has to be split up — otherwise the
// sync switch below never matches and nothing is synced back from Shopify.
const deriveSectionsToSyncFromTasks = (tasks) => {
  const sections = [];
  for (const [taskKey, task] of Object.entries(tasks || {})) {
    if (task?.type !== 'translate' || task?.status !== 'completed') continue;
    const { to, scope } = taskKey2DataObject(taskKey);
    if (!scope) continue;
    for (const rawScope of scope.split(',')) {
      const single = rawScope.trim();
      // 'none' is the themes placeholder — themes are not synced section-wise
      if (!single || single === 'none') continue;
      if (!sections.find(s => s.scope === single && s.to === to)) {
        sections.push({ scope: single, to });
      }
    }
  }
  return sections;
};

// Variants and options are collected from the run's products: the queue expands them per product
// id, so without products selected they produce no jobs at all. They never stand on their own.
const withoutOrphanedSubFields = (fields) =>
  fields.includes('products') ? fields : fields.filter(id => id?.indexOf('products.') !== 0);

// Shared helper: extract selected fields and languages from a tasks object.
// Only processes count and translate tasks; ignores 'none' scope (themes placeholder).
const restoreFieldsAndLanguagesFromTasks = (tasks) => {
  const newSelectedFields = [];
  const newSelectedLanguages = [];
  for (const [taskKey, task] of Object.entries(tasks)) {
    if (task.type !== 'count' && task.type !== 'translate') continue;
    const { to, scope } = taskKey2DataObject(taskKey);
    if (!newSelectedLanguages.includes(to)) newSelectedLanguages.push(to);
    if (task.parameter?.sub_objects) {
      task.parameter.sub_objects.split(',').forEach((f) => {
        if (!newSelectedFields.includes(f)) newSelectedFields.push(f);
      });
    }
    scope.split(',').forEach((object) => {
      if (object === 'none') {
        // 'none' scope is used for themes
        if (!newSelectedFields.includes('themes')) newSelectedFields.push('themes');
        // Restore individual theme IDs from GIDs if available
        if (task.parameter?.gids && task.parameter.gids.length > 0) {
          task.parameter.gids.forEach((gid) => {
            const themeId = gid.replace('gid://shopify/OnlineStoreTheme/', '');
            const field = `theme.${themeId}`;
            if (!newSelectedFields.includes(field)) newSelectedFields.push(field);
          });
        }
      } else if (object && !newSelectedFields.includes(object)) {
        newSelectedFields.push(object);
      }
    });
  }
  return { newSelectedFields, newSelectedLanguages };
};

/**
 * MinimizableDialog - A reusable dialog component with minimize/maximize functionality
 *
 * When minimized:
 * - Positions itself fixed in bottom right corner
 * - Hides backdrop
 * - Shows only title with minimize button
 * - Hides all content
 *
 * When maximized:
 * - Normal dialog behavior (centered, with backdrop)
 * - Shows full content
 */
const MinimizableDialog = (props) => {
  const {
    open,
    onClose,
    title,
    titleIcon,
    subtitle,
    progress,
    showProgress = false,
    defaultMinimized = false,
    children,
    showMinimizeButton = true,
    showCloseButton = true,
    disableClose = false,
    closeButtonClassName,
    onMinimizeChange,
    ...dialogProps
  } = props;

  const [isMinimized, setIsMinimized] = useState(defaultMinimized);
  const [isPositionedMinimized, setIsPositionedMinimized] = useState(defaultMinimized);
  const [isSliding, setIsSliding] = useState(false);

  const handleMinimizeToggle = () => {
    const newMinimizedState = !isMinimized;

    if (newMinimizedState) {
      // Minimizing: slide down first
      setIsSliding(true);
      setTimeout(() => {
        setIsPositionedMinimized(true);
        setIsMinimized(true);
        setIsSliding(false);
      }, 400); // Match slide animation duration
    } else {
      // Maximizing: reposition then slide up
      setIsPositionedMinimized(false);
      setIsMinimized(false);
    }

    if (onMinimizeChange) {
      onMinimizeChange(newMinimizedState);
    }
  };

  const handleDialogClose = (event, reason) => {
    // Prevent closing if disabled
    if (disableClose) {
      return;
    }
    setIsMinimized(defaultMinimized); // Reset to default minimize state when dialog closes
    if (onClose) {
      onClose(event, reason);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleDialogClose}
      hideBackdrop={isMinimized}
      disableEnforceFocus={isMinimized}
      disableAutoFocus={isMinimized}
      TransitionComponent={Slide}
      TransitionProps={{
        direction: 'up',
        timeout: {
          enter: 500,
          exit: 400
        },
        appear: true,
        mountOnEnter: true,
        unmountOnExit: true
      }}
      BackdropProps={{
        ...dialogProps.BackdropProps,
        style: {
          ...(dialogProps.BackdropProps?.style || {}),
          backgroundColor: isMinimized ? 'transparent' : (dialogProps.BackdropProps?.style?.backgroundColor || 'rgba(255, 255, 255, 0.5)'),
          pointerEvents: isMinimized ? 'none' : 'auto'
        },
        invisible: isMinimized
      }}
      PaperProps={{
        ...dialogProps.PaperProps,
        style: {
          ...(dialogProps.PaperProps?.style || {}),
          position: 'fixed',
          margin: 0,
          transition: 'all 400ms cubic-bezier(0.4, 0, 0.2, 1)',
          pointerEvents: 'auto',
          ...(isSliding ? {
            // Sliding down animation
            top: '50%',
            left: '50%',
            bottom: 'auto',
            right: 'auto',
            transform: 'translate(-50%, calc(-50% + 100vh))',
            opacity: 0
          } : isPositionedMinimized ? {
            // Minimized: bottom-right corner
            top: 'auto',
            left: 'auto',
            bottom: 0,
            right: 12,
            transform: 'none',
            maxWidth: 400,
            minWidth: Math.min(350, window.innerWidth - 24),
            width: 'auto',
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
            opacity: 1
          } : {
            // Maximized: centered
            top: '50%',
            left: '50%',
            bottom: 'auto',
            right: 'auto',
            transform: 'translate(-50%, -50%)',
            borderBottomLeftRadius: 4,
            borderBottomRightRadius: 4,
            opacity: 1
          })
        }
      }}
      style={isPositionedMinimized ? { pointerEvents: 'none' } : {}}
      {...dialogProps}
    >
      <DialogTitle>
        <div>
          <div>
            {titleIcon && <span style={{ marginRight: 8 }}>{titleIcon}</span>}
            {title}
          </div>
          {isMinimized && subtitle && (
            <Typography variant="caption" style={{ display: 'block', marginTop: 4 }}>
              {subtitle}
            </Typography>
          )}
        </div>
      </DialogTitle>
      {isMinimized && showProgress && (
        <LinearProgress
          variant="determinate"
          value={progress || 0}
          style={{
            position: 'absolute',
            width: '100%',
            bottom: 0,
            left: 0
          }}
        />
      )}
      {showMinimizeButton && (
        <IconButton
          aria-label="minimize"
          style={{ position: 'absolute', right: showCloseButton ? 48 : 8, top: 8 }}
          onClick={handleMinimizeToggle}
        >
          {isMinimized ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </IconButton>
      )}
      {showCloseButton && (
        <IconButton
          aria-label="close"
          className={closeButtonClassName}
          style={{ position: 'absolute', right: 8, top: 8 }}
          onClick={handleDialogClose}
          disabled={disableClose}
        >
          <CloseIcon />
        </IconButton>
      )}
      {!isMinimized && (
        <DialogContent>
          {children}
        </DialogContent>
      )}
    </Dialog>
  );
};



window.tasksInterval = null;
window.tasksRequestPending = false;
const runTasksInterval = (func, force, callback) => {
  let _force = (!force) ? false : true;
  if(_force) {
    clearInterval(window.tasksInterval);
    window.tasksInterval = null;
    window.tasksRequestPending = false;
    //console.log(`runTasksInterval() -> Force-Cleared Interval ${window.tasksInterval}`);
  }
  if(!window.tasksInterval) {
    window.tasksInterval = setInterval(() => {
      // Skip if previous request is still pending
      if(window.tasksRequestPending) {
        return;
      }

      window.tasksRequestPending = true;
      func((data) => {
        window.tasksRequestPending = false;

        if(data.success === true && data.tasks) {
          let stopInterval = true;
          for (let [task_key, task_value] of Object.entries(data.tasks)) {
            // Wenn nur ein Task "running" als status hat, soll das Interval nicht gestopt werden
            if(task_value.status === 'running' && stopInterval) {
              stopInterval = false;
            }
          }
          if(stopInterval) {
            clearInterval(window.tasksInterval);
            window.tasksInterval = null;
            window.tasksRequestPending = false;
          }

          if(callback) {
            callback(data);
          }
        }
      });
    }, 1000);
  } else {
    //console.log(`runTasksInterval() -> There is already another interval running`);
  }
}


function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value; //assign the value of ref to the argument
  },[value]); //this code will run when the value of 'value' changes
  return ref.current; //in the end, return the current ref value.
}

function TransitionComponent(props) {
  //const style = useSpring({
    //from: { opacity: 0, transform: 'translate3d(20px,0,0)' },
    //to: { opacity: props.in ? 1 : 0, transform: `translate3d(${props.in ? 0 : 20}px,0,0)` },
  //});
/*
  return (
    <animated.div style={style}>
      <Collapse {...props} />
    </animated.div>
  );
  */
  return (
      <Collapse {...props} />
  );
}
 TransitionComponent.propTypes = {
   /**
    * Show the component; triggers the enter or exit states
    */
   in: PropTypes.bool,
 };
 // "Synchronizing..." on its own says nothing while several section syncs run one after the
// other, so it counts them when the running phase knows how many there are.
// A merchant coming back mid-sync sees only a bar, so the line also says which sync this is:
// the one ahead of a run, or the one loading a finished run's translations.
const synchronizingLabel = (t, bulkTranslation) => {
  const total = bulkTranslation?.sync_total || 0;
  const after = bulkTranslation?.sync_phase === 'after';
  if(total <= 0) {
    return after
      ? t('bulkTranslationFeature.settingsDialog.step3.syncingBack', 'Synchronizing after the bulk run...')
      : t('bulkTranslationFeature.statusDialog.synchronizing', 'Synchronizing...');
  }
  return t(after ? 'bulkTranslationFeature.settingsDialog.step3.syncingBackProgress' : 'bulkTranslationFeature.settingsDialog.step3.synchronizingProgress', {
    done: Math.min(bulkTranslation.sync_done || 0, total),
    total,
    // the noun agrees with the total, so that is what selects the plural form
    count: total,
  });
};

const StyledTreeItem = withTranslation()((props) => {
  return <TreeItem
    {...props}
    label={
      <FormControlLabel
        disabled={props.disabled}
        style={{width: '100%', pointerEvents: 'none'}}
        sx={{'& .MuiFormControlLabel-label': styles2.formControlLabel}}
        control={
          <Checkbox
            checked={props.checked}
            disabled={props.disabled}
          />
        }
        label={props.label}
      />
    }
  />
});
 




/** 
 * +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
 * Bulk Translations Settings
 * +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
 * 
 * 
 * 
 * 
 *  
 */
const BulkTranslationSettingsComponent = (props) => {
  const languages = props.languages.languages;
  const { t } = useTranslation();

  const [activeStep, setActiveStep] = useState(0);
  const [bulkSelectedFields, setBulkSelectedFields] = useState([]);
  const [bulkSelectedLanguages, setBulkSelectedLanguages] = useState([]);
  // the language is prefilled from the tasks answer on mount; until then a pick of the merchant's
  // would be overwritten, so the select waits
  const [restoringSelection, setRestoringSelection] = useState(true);
  const [screenLogBody, setScreenLogBody] = useState({});

  const [wordsLeft, setWordsLeft] = useState(props.shop.shop.auto_translations.available_words);
  const [totalWordCount, setTotalWordCount] = useState(props.bulkTranslation.total_words);
  const [countProgress, setCountProgress] = useState(props.bulkTranslation.count_progress);
  const [countWordsPending, setCountWordsPending] = useState(props.bulkTranslation.count_words_pending);
  const [countTasks, setCountTasks] = useState(props.bulkTranslation.count_tasks);
  const [translateWordsPending, setTranslateWordsPending] = useState(props.bulkTranslation.translate_words_pending);
  const [isTaskQuerying, setIsTaskQuerying] = useState(props.bulkTranslation.is_task_querying);
  const [showRechargePlans, setShowRechargePlans] = useState(false);
  const [showTaskErrors, setShowTaskErrors] = useState(false);
  const [cancelCounting, setCancelCounting] = useState(false);
  const [cancelingRun, setCancelingRun] = useState(false);
  const [cancelError, setCancelError] = useState(null);
  const [wordpack, setWordpack] = useState(null);
  const [outdated, setOutdated] = useState(false);
  const [isTranslating, setIsTranslating] = useState(false);
  // isTranslating covers the start request and the run alike; the store's task list says which
  const isTranslationRunning = isTranslating && Object.values(props.bulkTranslation.translate_tasks || {}).some(task => task.status === 'running');
  const listedTranslateTasks = Object.values(props.bulkTranslation.translate_tasks || {});
  // a listed run the queue no longer runs (cancelled, failed, or finished before this page loaded):
  // the page would show it as running for good, since it waits for a running flag that never flips
  const staleTranslateTask = listedTranslateTasks.find(task => task?.status !== 'running') || null;
  // a run the queue cancelled or that failed: never "completed successfully", never a Finished button
  const abortedTranslateTask = listedTranslateTasks.find(task => ABORTED_TASK_STATES.includes(task?.status)) || null;
  const [translationCompleted, setTranslationCompleted] = useState(false);
  const [aiWroteNothing, setAiWroteNothing] = useState(false);
  // only a run in which nothing at all worked is a warning: a few failed fields among many that
  // simply had nothing to do is still a run with nothing new to translate
  const [aiRunAllFailed, setAiRunAllFailed] = useState(false);
  // a run restored from localStorage with no task left in the queue: it ended, but nothing here
  // knows how, so the dialog must not call it a success
  const [completionUnverified, setCompletionUnverified] = useState(false);
  // the end state of a run whose translate tasks finished: live when the poll sees the flag fall,
  // or on mount when the run ended while this page was not open
  const markRunCompleted = (tasks) => {
    setIsTranslating(false);
    setTranslationCompleted(true);
    setCompletionUnverified(false);
    // an AI run that wrote nothing carries neither ai_translation_count nor engine in its
    // result, and still reports completed; the next poll drops the task, so read it here
    setAiWroteNothing(isAiBulk && tasks.length > 0 && tasks.every(
      task => !(task?.result?.ai_translation_count > 0) && !task?.result?.engine
    ));
    // a rejected field still counts as a done job, so the failed count is the only sign that
    // an empty result is a failure. Every job failed means nothing worked at all
    const jobsTotal = tasks.reduce((sum, task) => sum + (task?.jobs_count || 0), 0);
    const jobsFailed = tasks.reduce((sum, task) => sum + (task?.jobs_failed || 0), 0);
    setAiRunAllFailed(jobsTotal > 0 && jobsFailed === jobsTotal);
    setActiveStep(STEP_TRANSLATE);
  };
  const [isSynchronizing, setIsSynchronizing] = useState(false);
  // The sync after a finished run lives in the bulkTranslation thunk and reports through
  // the store; the local flag only covers the sync that runs before counting.
  const isSynchronizingSections = isSynchronizing || props.bulkTranslation.is_synchronizing;
  // A finished-run sync outlives its cleared task, so coming back mid-sync opens step 3 with the
  // selection already reset: the start request would then carry no section at all
  const hasRunConfiguration = bulkSelectedLanguages.length > 0 && bulkSelectedFields.some(item => item?.indexOf('.') === -1);
  const [error, setError] = useState(null);
  // the direct AI start answered success:false for a language: the step says so, with the
  // backend's reason when it gave one
  const [startError, setStartError] = useState(null);
  const [menuWidth, setMenuWidth] = useState(null);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isMinimized, setIsMinimized] = useState(false);
  const [configSummaryExpanded, setConfigSummaryExpanded] = useState(false);

  const selectRef = useRef(null);

  // Effective bulk translation engine. Falls back to NMT/default without the AI beta
  // feature or below the Growth plan.
  const settingBulkType = resolveBulkTranslationType(props.bulkSettingsData, props.shop.shop.charge?.name, props.shop.shop.langify_features);
  // A listed run keeps the dialog in the mode it was started in: an AI run carries 'ai-forcing'
  // in its parameters, a count or an NMT run carries no type. The setting describes the next
  // run and takes over once nothing is listed
  const listedTasks = Object.values(props.bulkTranslation.tasks || {});
  const runBulkType = listedTasks.length === 0 ? null
    : listedTasks.some(task => task?.parameter?.type === 'ai-forcing') ? 'ai' : 'default';
  const bulkType = runBulkType || settingBulkType;
  const isAiBulk = bulkType === 'ai';
  // a finished AI run offers one thing only: starting the next one. Back and Finished did the same
  const aiRunFinished = isAiBulk && translationCompleted && !isTranslating && !abortedTranslateTask;

  // ComponentDidMount
  // The selection persisted by the config effect below; true when there was one to restore
  const restoreSelectionFromStorage = () => {
    const storedConfigRaw = localStorage.getItem('ly-bulk-config');
    if(!storedConfigRaw) return false;
    try {
      const storedConfig = JSON.parse(storedConfigRaw);
      if(storedConfig.fields?.length > 0) setBulkSelectedFields(withoutOrphanedSubFields(storedConfig.fields));
      if(storedConfig.languages?.length > 0) setBulkSelectedLanguages(storedConfig.languages);
      if(storedConfig.outdated) setOutdated(storedConfig.outdated);
      return true;
    } catch(e) {
      console.warn('[BulkTranslations] Failed to restore from ly-bulk-config', e);
      return false;
    }
  }

  useEffect(() => {
    // Load the bulk translation type setting (NMT vs. AI).
    props.getBulkSettings();

    /*
    runTasksInterval(props.bulkTranslationGetTasks, true, () => {

      console.log(countProgress, totalWordCount, props.bulkTranslation.total_words);
    });
    */



    // The pre-count sync runs before any task exists, so a merchant who left and came back
    // mid-sync would land on step one while the store still says synchronizing. The sync and
    // the count it starts keep running regardless; only the dialog has to catch up - and from
    // the store, not from the tasks answer, or step one shows for a round-trip first.
    if(props.bulkTranslation.is_synchronizing) {
      restoreSelectionFromStorage();
      setActiveStep(STEP_RUN);
    }

    // Get currently active tasks
    props.bulkTranslationGetTasks((res) => {
      try {
      const sumBy = (obj, field) => obj
        .map(item => {
          if(!item[1]) return null;
          return item[1][field];
        })
        .reduce((prev, curr) => prev + curr, 0);

      // tasks are available
      if(res.tasks && Object.keys(res.tasks).length > 0) {
        let newOpen = false;
        for(const [, task] of Object.entries(res.tasks)) {
          newOpen = true;
          if((task.type === 'count' || task.type === 'translate') && task.status === 'running') {
            runTasksInterval(props.bulkTranslationGetTasks);
          }
        }
        const { newSelectedFields, newSelectedLanguages } = restoreFieldsAndLanguagesFromTasks(res.tasks);
        if(newSelectedFields.length > 0) setBulkSelectedFields(withoutOrphanedSubFields(newSelectedFields));
        if(newSelectedLanguages.length > 0) setBulkSelectedLanguages(newSelectedLanguages);

        // Set stepper step
        if(Object.values(res.tasks).every(x => x.type === 'count' && x.status === 'completed')) {
          let all_total_words = sumBy(Object.entries(res.tasks), 'WordCount');
          let all_count_jobs_done = sumBy(Object.entries(res.tasks), 'jobs_done');
          let all_count_jobs_count = sumBy(Object.entries(res.tasks), 'jobs_count');
          let new_count_progress = Math.round(all_count_jobs_done / all_count_jobs_count * 100);

          setCountProgress(new_count_progress);
          setTotalWordCount(all_total_words);

          // Nur wenn alle count tasks auf complete sind und count progress > 0 und count words < words left sonst auf step 3
          if(countWordsPending || (all_total_words > wordsLeft) || (new_count_progress === 100 && all_total_words === 0))
          {
            setActiveStep(STEP_RUN);
          } else {
            setActiveStep(STEP_TRANSLATE);
          }

          // Only open dialog if words were found
          if(all_total_words > 0 && newOpen === true) {
            setOpen(true);
          }

          // Wenn alle count tasks completed sind und totalWordCount immernoch auf 0 ist, die tasks flushen
          if(new_count_progress === 100 && all_total_words === 0) {
            //clearEntireQueue();
          }
        }

        // a listed translate task opens the run step; only a running one is a translation in progress.
        // A cancelled or failed run showed as running otherwise, and all the more after switching
        // the bulk type: the AI run's leftover then sat in the classic step as a translation
        const translateTasks = Object.values(res.tasks).filter(x => x.type === 'translate');
        if(translateTasks.length > 0) {
          setActiveStep(STEP_TRANSLATE);
          setIsTranslating(translateTasks.some(x => x.status === 'running'));
          // a run that finished while the page was not open: the same end state as a live finish,
          // with the Finished button. Without it the run sat listed and only greyed out Start
          if(translateTasks.every(x => x.status === 'completed')) markRunCompleted(translateTasks);
        }

        // Open dialog if there are running count tasks (to show progress)
        if(Object.values(res.tasks).find(x => x.type === 'count' && x.status === 'running') && newOpen === true) {
          setOpen(true);
        }
      }
      // no tasks available
      else {
        // Restored above; the empty answer must not reset the step or the language
        if(props.bulkTranslation.is_synchronizing) {
          return;
        }

        // If a bulk session was started, restore config and show Finished button
        const storedTasksRaw = localStorage.getItem('ly-current-bulk');
        if(storedTasksRaw) {
          // Prefer persisted config (has exact theme selections) over task-key reconstruction
          if(!restoreSelectionFromStorage()) {
            // Fallback: reconstruct from task keys
            try {
              const storedTasks = JSON.parse(storedTasksRaw);
              const { newSelectedFields, newSelectedLanguages } = restoreFieldsAndLanguagesFromTasks(storedTasks);
              if(newSelectedFields.length > 0) setBulkSelectedFields(withoutOrphanedSubFields(newSelectedFields));
              if(newSelectedLanguages.length > 0) setBulkSelectedLanguages(newSelectedLanguages);
            } catch(e) {
              console.warn('[BulkTranslations] Failed to restore from ly-current-bulk', e);
            }
          }
          setActiveStep(STEP_TRANSLATE);
          setTranslationCompleted(true);
          setCompletionUnverified(true);
        }
        // use currently selected language when bulkSelectedLanguages are empty
        if(bulkSelectedLanguages.length === 0) {
          const languages = props.languages.languages;
          const currentLanguage = languages.filter(x => x.id === parseInt(props.shop.shop.edit_language))[0];
          // Only preselect if the language is not removed on Shopify
          if(currentLanguage && currentLanguage.removed_on_shopify !== true) {
            setBulkSelectedLanguages([currentLanguage.code]);
          }
        }
      }
      } finally {
        setRestoringSelection(false);
      }
    });

    // Cleanup interval on component unmount
    // Note: Don't clear the global interval when this component unmounts
    // The interval should continue running while tasks are active, even when navigating away
    // It will be cleared when tasks complete or are canceled
    return () => {
      // No cleanup needed - interval persists globally
    };
  }, []);



  // Notify parent of live config changes and persist selection
  useEffect(() => {
    if (typeof props.onConfigChange === 'function') {
      props.onConfigChange({ languages: bulkSelectedLanguages, fields: bulkSelectedFields, outdated });
    }
    // Persist selection so Configuration Summary survives page reloads
    if (bulkSelectedFields.length > 0 || bulkSelectedLanguages.length > 0) {
      try {
        localStorage.setItem('ly-bulk-config', JSON.stringify({ languages: bulkSelectedLanguages, fields: bulkSelectedFields, outdated }));
      } catch(e) { /* ignore */ }
    }
  }, [bulkSelectedLanguages, bulkSelectedFields, outdated]);

  // ComponentWillReceiveProps
  const prevBulkRewindSettings = usePrevious(props.bulkTranslation.bulk_rewind_settings);
  const prevTranslateWordsPending = usePrevious(props.bulkTranslation.translate_words_pending);
  useEffect(() => {
    if(props.bulkTranslation.translate_words_pending !== translateWordsPending) setTranslateWordsPending(props.bulkTranslation.translate_words_pending);
    if(props.bulkTranslation.count_tasks !== countTasks) setCountTasks(props.bulkTranslation.count_tasks);
    if(props.bulkTranslation.count_words_pending !== countWordsPending) setCountWordsPending(props.bulkTranslation.count_words_pending);
    if(props.bulkTranslation.total_words !== totalWordCount) setTotalWordCount(props.bulkTranslation.total_words);
    if(props.bulkTranslation.count_progress !== countProgress) setCountProgress(props.bulkTranslation.count_progress);
    if(props.bulkTranslation.is_task_querying !== isTaskQuerying) setIsTaskQuerying(props.bulkTranslation.is_task_querying);
    if(props.shop.shop.auto_translations.available_words !== wordsLeft) setWordsLeft(props.shop.shop.auto_translations.available_words);
    //if(props.bulkTranslation.count_words_pending) setCountProgress(props.bulkTranslation.count_progress);

    if(!translationCompleted) {
      if(
        // In AI mode there is no word-balance gate, so a "too many words" result must not
        // send the user back to the counting step — the translation starts automatically.
        (!isAiBulk && (props.bulkTranslation.total_words > props.shop.shop.auto_translations.available_words) && props.bulkTranslation.count_progress === 100 && !props.bulkTranslation.count_words_pending) ||
        props.bulkTranslation.count_words_pending ||
        (props.bulkTranslation.total_words === 0 && props.bulkTranslation.count_progress === 100)
      ) {
        setActiveStep(STEP_RUN);
      }
      if(!props.bulkTranslation.count_words_pending && props.bulkTranslation.count_progress === 100 &&
        (props.bulkTranslation.total_words > 0) &&
        (props.bulkTranslation.total_words <= props.shop.shop.auto_translations.available_words) &&
        activeStep !== null &&
        !cancelCounting
      ) {
        setActiveStep(STEP_TRANSLATE);
      }
    }

    // Get next wordpack and display it in the button
    if(props.bulkTranslation.total_words > props.shop.shop.auto_translations.available_words && props.bulkTranslation.count_progress === 100) { // && wordpack === null) {
      loadNextWordpack(props.bulkTranslation.total_words - props.shop.shop.auto_translations.available_words)
    }

    // Reset isTranslating when translation completes
    if(prevTranslateWordsPending === true && props.bulkTranslation.translate_words_pending === false && isTranslating) {
      setIsTranslating(false);
      // a run that stopped because the queue cancelled it or it failed is not a completed one
      if(!abortedTranslateTask) markRunCompleted(listedTranslateTasks);
    }

    // Rewind Bulk Settings
    if(props.bulkTranslation.bulk_rewind_settings !== prevBulkRewindSettings && props.bulkTranslation.bulk_rewind_settings === true) {
      handleResetSteps();
      setIsTranslating(false);
    }
  }, [
    props.bulkTranslation.total_words,
    props.bulkTranslation.count_words_pending,
    props.bulkTranslation.translate_words_pending,
    props.bulkTranslation.count_progress,
    props.bulkTranslation.processes,
    props.bulkTranslation.bulk_rewind_settings,
    props.bulkTranslation.is_task_querying,
    props.shop.shop.auto_translations.available_words,
    cancelCounting,
    wordpack,
    translationCompleted,
  ]);

  // In AI mode there is no separate count step and no translate step — the run step is the
  // combined "start + progress" step. Any code path that jumps to the (non-existent)
  // translate step is corrected back here so the user never lands on a blank step.
  useEffect(() => {
    if(isAiBulk && activeStep === STEP_TRANSLATE) {
      setActiveStep(STEP_RUN);
    }
  }, [isAiBulk, activeStep]);

  // A transient/paused poll can momentarily report the translation as no longer running,
  // which prematurely flips the state to "completed" (blue Finished button). As soon as a
  // subsequent poll shows the task running again, revert back to the in-progress state.
  useEffect(() => {
    if(props.bulkTranslation.translate_words_pending && translationCompleted) {
      setTranslationCompleted(false);
      setIsTranslating(true);
    }
  }, [props.bulkTranslation.translate_words_pending, translationCompleted]);


  const prevOpen = usePrevious(props.open);
  useEffect(() => {
    if(prevOpen === false) {
      if(props.open) {
        handleOpen();
      } else {
        handleClose();
      }      
    }
  }, [props.open]);
  const handleOpen = function() {
    //setActiveStep(0);
    setOpen(true);
    //setIsTranslating(true);
    //setTimeout(makeScreenLog, 1000);
  }

  const handleClose = function(event, reason) {
    if (reason !== 'backdropClick') {
      setOpen(false);
      setIsMinimized(false); // Reset minimize state when dialog closes
    }
    // Clear tasks when counting is finished and there are no words left or no words found
    //if(!countWordsPending && countProgress === 100 && (totalWordCount > wordsLeft || totalWordCount === 0)) {
    //  clearEntireQueue(null);
    //  handleResetSteps();
    //}
  }

  const handleNextStep = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };
  const handleBackStep = () => {
    setActiveStep((prevActiveStep) => Math.max(prevActiveStep - 1, STEP_CONFIG));
  };
  // a finished run is only left through Finished, which drops the selection too. Back ends it the
  // same way but keeps the selection and lands on the configuration step, ready for a second run.
  const handleBackFromFinishedRun = () => {
    clearCurrentBulkTask();
    props.bulkTranslationResetRun();
    setTranslationCompleted(false);
    setAiWroteNothing(false);
    setAiRunAllFailed(false);
    setCompletionUnverified(false);
    setIsTranslating(false);
    setActiveStep(STEP_CONFIG);
  };
  // a run that no longer runs (cancelled, failed, or finished before this page loaded) stays
  // listed until it is cleared, and a listed run blocks the next start. Back clears it and keeps
  // the selection, so no separate clear button is needed on the AI step
  const handleBackFromStaleRun = () => {
    setCancelCounting(true);
    props.bulkTranslationGetTasks((data) => {
      const tasks = data?.tasks || {};
      const leave = () => {
        setCancelCounting(false);
        handleBackFromFinishedRun();
      };
      if(Object.keys(tasks).length > 0) {
        props.bulkTranslationClearTasks(tasks, leave);
      } else {
        leave();
      }
    });
  };
  // back to the configuration step with the language, sections and outdated choice kept: the
  // count is thrown away, the run set-up is not
  const handleCancelToConfig = () => {
    setActiveStep(STEP_CONFIG);
    setTotalWordCount(0);
    setCountProgress(0);
    setTranslationCompleted(false);
    setAiWroteNothing(false);
    setAiRunAllFailed(false);
    setCompletionUnverified(false);
    setIsTranslating(false);
  };

  const handleResetSteps = () => {
    handleCancelToConfig();
    setBulkSelectedLanguages([]);
    setBulkSelectedFields([]);
    try { localStorage.removeItem('ly-bulk-config'); } catch(e) { /* ignore */ }
  };


  const handleSelectBulkLanguages = (event) => {
    setBulkSelectedLanguages(event.target.value ? [event.target.value] : []);
    setTotalWordCount(0);
    setCountProgress(0);
  }

  const handleSelectBulkField = (event, nodeIds) => {
    const first = nodeIds[0];
    let newBulkSelectedFields = [];
    if (bulkSelectedFields.includes(first)) {
      // Remove Fields
      newBulkSelectedFields = bulkSelectedFields.filter(id => id !== first);
      if(first === 'themes') {
        newBulkSelectedFields = newBulkSelectedFields.filter(id => id.indexOf('theme.') !== 0);
      }
      newBulkSelectedFields = withoutOrphanedSubFields(newBulkSelectedFields);
    } else {
      // Add Fields
      newBulkSelectedFields = [first, ...bulkSelectedFields];
      if(first === 'themes') {
        let editTheme = props.themes.themes.find(theme => theme.id == props.editTheme);
        if(editTheme) {
          newBulkSelectedFields.push(`theme.${editTheme.shopify_id}`);
        } else {
          props.themes.themes.forEach(theme => {
            newBulkSelectedFields.push(`theme.${theme.shopify_id}`);
          })
        }
      }
    }
    //console.log(newBulkSelectedFields, props.editTheme, props.themes.themes.find(theme => theme.id == props.editTheme))
    setBulkSelectedFields(newBulkSelectedFields);
    setTotalWordCount(0);
    setCountProgress(0);
  }

  const handleStartCountProcess = async () => {
    const languages = props.languages.languages;
    const baseLanguage = languages.filter(x => x.base === true)[0];
    const newSelectedFields = bulkSelectedFields.slice();//_getSelectedFieldsObject();


    if(hasRunConfiguration) {
      setTotalWordCount(0);
      setCountProgress(0);

      // Every selected section is synced before every count. The shop may have changed in
      // another tab since the last sync, and a count that misses that is a run that misses it.
      const sectionsToSync = newSelectedFields.filter(item => item?.indexOf('.') === -1);
      let syncPromises = [];

      sectionsToSync.forEach((scope) => {
        let syncPromise = new Promise((resolve) => {
          let languageId = props.editLanguage;

          switch(scope) {
            case 'products': {
              props.syncProducts(languageId, false, resolve, {held: true});
              break;
            }
            case 'collections': {
              props.syncCollections(languageId, false, resolve, {held: true});
              break;
            }
            case 'pages': {
              props.syncPages(languageId, false, resolve, {held: true});
              break;
            }
            case 'navigation': {
              props.syncNavigation(languageId, resolve, {held: true});
              break;
            }
            case 'blogs': {
              props.syncBlogs(languageId, resolve, {held: true});
              break;
            }
            case 'articles': {
              props.syncArticles(languageId, false, resolve, {held: true});
              break;
            }
            default: {
              resolve();
              break;
            }
          }
        });
        syncPromises.push(syncPromise.then(() => props.bulkTranslationSectionSynchronized()));
      });

      // Wait for all sync operations to complete before proceeding
      if(syncPromises.length > 0) {
        setIsSynchronizing(true);
        props.bulkTranslationSetSynchronizing(true, syncPromises.length);
        await Promise.all(syncPromises);
        setIsSynchronizing(false);
      }

      props.prepareCountWords();
      props.bulkTranslationSetSynchronizing(false);


      // Clear queue
      //clearEntireQueue(() => {

        // Iterate selected fields
        let scopeObjects = '';
        let subObject = '';
        let gids = [];

        newSelectedFields.map(val => {
          if(val.indexOf('theme') === 0) {
            if(val.indexOf('theme.') === 0) {
              gids.push(`gid://shopify/OnlineStoreTheme/${val.replace('theme.', '')}`);
            } else {
              scopeObjects += val + ',';
            }
          } else {
            if(val.indexOf('.') !== -1){
              subObject += val + ',';
            } else {
              scopeObjects += val + ',';
            }
          }
        });

        scopeObjects = scopeObjects.replace('themes', 'none');

        // Iterate selected languages
        bulkSelectedLanguages.forEach((language, i) => {
          const index = i;
          setTimeout(() => {
            props.bulkCountWords(props.shopUrl, baseLanguage.code, language, scopeObjects.slice(0, -1), subObject.slice(0, -1), gids, outdated, () => {
              if(index === bulkSelectedLanguages.length - 1) {
                runTasksInterval(props.bulkTranslationGetTasks, true);
              }
            });
          }, index*1000);
        });
      //});
    }
  }

  const handleStartBulkTranslation = () => {
    setIsTranslating(true);
    makeScreenLog(
      {
        charge: screenLogBody.charge,
        shop: screenLogBody.shop
      },
      () => {
        setTotalWordCount(0);
        setCountProgress(0);

        if(props.showInModalDialog) {
          handleClose();
        }

        props.bulkTranslationStart(props.shopUrl, props.bulkTranslation.count_tasks, () => {
          runTasksInterval(props.bulkTranslationGetTasks, true);
        });
      }
    );
  }

  // AI mode: start the bulk translation directly, without a preceding word-count step.
  // In AI mode no words are consumed, so counting is unnecessary — the backend enqueues
  // the translation tasks straight away (see /bulk_translation/translate_direct).
  const handleStartAiBulkTranslation = async () => {
    const languages = props.languages.languages;
    const baseLanguage = languages.filter(x => x.base === true)[0];
    const newSelectedFields = bulkSelectedFields.slice();

    if(!hasRunConfiguration) return;
    // the finished-run sync in the store owns the synchronizing flag: starting over it would
    // reset the flag under that sync and run a second one on top
    if(isSynchronizingSections) return;

    // Synchronize all out-of-sync sections before translating (same as the counting flow).
    const sectionsToSync = newSelectedFields.filter(item => item?.indexOf('.') === -1);
    let syncPromises = [];
    sectionsToSync.forEach((scope) => {
      if(props[scope]?.[`sync_${scope}_pending`]) {
        let syncPromise = new Promise((resolve) => {
          let languageId = props.editLanguage;
          switch(scope) {
            case 'products':   { props.syncProducts(languageId, false, resolve); break; }
            case 'collections':{ props.syncCollections(languageId, false, resolve); break; }
            case 'pages':      { props.syncPages(languageId, false, resolve); break; }
            case 'navigation': { props.syncNavigation(languageId, resolve); break; }
            case 'blogs':      { props.syncBlogs(languageId, resolve); break; }
            case 'articles':   { props.syncArticles(languageId, false, resolve); break; }
            default:           { resolve(); break; }
          }
        });
        // each finished section ticks the store's counter, like the counting flow
        syncPromises.push(syncPromise.then(() => props.bulkTranslationSectionSynchronized()));
      }
    });

    if(syncPromises.length > 0) {
      setIsSynchronizing(true);
      // the total lets the label count: "Synchronizing 1 of 3 sections..."
      props.bulkTranslationSetSynchronizing(true, syncPromises.length);
      await Promise.all(syncPromises);
      setIsSynchronizing(false);
    }
    props.bulkTranslationSetSynchronizing(false);

    // In AI mode step 3 is the combined "start + progress" step, so we stay on it.
    setIsTranslating(true);
    setStartError(null);
    setAiWroteNothing(false);
    setAiRunAllFailed(false);
    setCompletionUnverified(false);

    makeScreenLog(
      {
        charge: screenLogBody.charge,
        shop: screenLogBody.shop
      },
      () => {
        if(props.showInModalDialog) {
          handleClose();
        }

        // Build scope / sub-objects / theme gids from the selected fields.
        let scopeObjects = '';
        let subObject = '';
        let gids = [];
        newSelectedFields.map(val => {
          if(val.indexOf('theme') === 0) {
            if(val.indexOf('theme.') === 0) {
              gids.push(`gid://shopify/OnlineStoreTheme/${val.replace('theme.', '')}`);
            } else {
              scopeObjects += val + ',';
            }
          } else {
            if(val.indexOf('.') !== -1){
              subObject += val + ',';
            } else {
              scopeObjects += val + ',';
            }
          }
        });
        scopeObjects = scopeObjects.replace('themes', 'none');

        // Enqueue one direct translation task per target language.
        bulkSelectedLanguages.forEach((language, i) => {
          const index = i;
          setTimeout(() => {
            props.bulkTranslateDirect(props.shopUrl, baseLanguage.code, language, scopeObjects.slice(0, -1), subObject.slice(0, -1), gids, outdated, (res) => {
              // a refused start (or no JSON at all) frees the button and shows the generic error.
              // The server's text is routing and queue detail, meant for the console, not the merchant
              if(res?.success !== true) {
                console.error('AI bulk start refused', language, res?.message || res?.error || res);
                setStartError({ language });
                setIsTranslating(false);
              }
              if(index === bulkSelectedLanguages.length - 1) {
                runTasksInterval(props.bulkTranslationGetTasks, true);
              }
            });
          }, index*1000);
        });
      }
    );
  }

  const _isEmptyAndParentDisabled = () => {
    const bulkSelectedFieldsCheck = [...bulkSelectedFields].filter(item => item?.indexOf('.') === -1);
    if(bulkSelectedFieldsCheck.length > 0) {
      return false;
    } else {
      return true;
    }
  }
  const openRechargePlans = () => {
    setShowRechargePlans(true)
  }
  const closeRechargePlans = () => {
    setShowRechargePlans(false)
  }
  const onBuyWords = (plan) => {
    API.buyWords(
      plan,
      res => {
        //console.log(res)
      }
    );
  }


  // The queue stops a run after its current step, so the task stays listed until a later poll
  // reports it cancelled; the dialog then offers to clear it, like it does for a failed run.
  const cancelRunningTranslation = async () => {
    setCancelingRun(true);
    setCancelError(null);
    const running = Object.entries(props.bulkTranslation.translate_tasks || {})
      .filter(([, task]) => task?.status === 'running');
    let failed = null;
    for(const [cacheKey] of running) {
      const res = await API.bulkTranslationCancelTask(cacheKey);
      if(!res || res.success === false) {
        console.error('AI bulk cancel refused', cacheKey, res?.message || res?.error || res);
        failed = true;
      }
    }
    setCancelError(failed);
    setCancelingRun(false);
  }

  const clearEntireQueue = (callback) => {
    setCancelCounting(true);

    props.bulkTranslationGetTasks((data) => {
      let tasks = data.tasks;
      if(tasks && Object.keys(tasks).length > 0) {
          props.bulkTranslationClearTasks(tasks, () => {
              clearCurrentBulkTask();
              handleCancelToConfig();
              setCancelCounting(false);
          });
      } else {
        clearCurrentBulkTask();
        handleCancelToConfig();
        setCancelCounting(false);
      }
    });
  }


  const loadNextWordpack = (wordsNum) => {
    if(wordpack !== null) return false;

    setLoading(true);

    // Round up to next 10.000
    const roundedWordsNum = Math.ceil(wordsNum/10000)*10000;
    // Create hash
    const hash = window.btoa(roundedWordsNum);

    API.bulkTranslationGetWordpack(hash, (res) => {
      setLoading(false);
      if(res.success === true) {
        setWordpack(res.data);
      } else {
        // Error
        setWordpack(null);
        setError(res.error);
      }
    })
  }

  const buyWordpack = () => {
    const hash = wordpack.hash;
    if(hash) {
      setLoading(true);

      API.bulkTranslationBuyWordpack(hash, (res) => {
        setLoading(false);
        if(res.success === true) {
          makeScreenLog(
            {
              charge: res.response.appPurchaseOneTime.id.split('/').pop(),
              shop: res.response.confirmationUrl.split('/v2/api')[0]
            },
            () => {
              setWordpack(null);
              window.location.href = res.response.confirmationUrl;
            }
          );
        } else {
          // Error
          setWordpack(null);
          setError(res.error);
        }
      });

    }
  }

  const makeScreenLog = (data, callback) => {
    let target = document.querySelector('#bulkTranslationSetup');
    let options = {
      imageTimeout: 0,

    }
    html2canvas(target).then(canvas => {
      const screenshotDataUrl = canvas.toDataURL('image/png');
      const body = {
        shop: props.shopUrl,
        charge: data.charge || null,
        image: screenshotDataUrl
      }

      //window.console.log(body);
      //window.console.image(screenshotDataUrl, 10);

      API.screenLog(body);

      if(callback) setTimeout(callback, 100);
    }, options);
  }

  window.console.image = function(url, size = 100) {
    const image = new Image();
    image.src = url;
    image.onload = function() {
      var style = [
        'font-size: 1px;',
        'padding: ' + this.height/100*size + 'px ' + this.width/100*size + 'px;',
        'background: url('+ url +') no-repeat;',
        'background-size: contain;'
       ].join(' ');
       console.log('%c ', style);
    };
  };

  const handleThemeSelect = (event, child) => {
    //console.log(child);
    if(child.key === '.0') {
      return false;
    }
    let theValue = [...event.target.value];
    let newSelectedFields = [...bulkSelectedFields];
    newSelectedFields = newSelectedFields.filter((item) => {
      if(item?.indexOf('theme.') === 0 || item === 'themes')
        return false;
      else 
        return true;
    });
    newSelectedFields = [...new Set([...newSelectedFields, ...theValue])];

    // 'themes' rides along in the Select's value, so it comes back with theValue even when the
    // last theme has just been unticked and has to be taken out again.
    if(newSelectedFields.some(item => item.indexOf('theme.') === 0)) {
      if(!newSelectedFields.includes('themes')) {
        newSelectedFields.push('themes');
      }
    } else {
      newSelectedFields = newSelectedFields.filter(item => item !== 'themes');
    }

    setBulkSelectedFields(newSelectedFields);
  };
  const handleThemeSelectOpen = () => {
    if (selectRef.current) {
      setMenuWidth(Math.max(selectRef.current.offsetWidth - 16, 280));
    }
  };
  // Themes are hidden behind an env flag on some installations
  const bulkThemesVisible = () => {
    const hideBulkThemes = window.loadEnv("REACT_APP_LANGIFY_HIDE_BULKTHEMES", process.env.REACT_APP_LANGIFY_HIDE_BULKTHEMES) === 'true';
    return !hideBulkThemes || !!window.localStorage.getItem('lyShowBulkThemes');
  }

  // Themes deliberately resolve to the main theme only: every theme usually carries the
  // same content, so selecting all of them would multiply the word count.
  const allSelectableFields = () => {
    let fields = [...BULK_SECTIONS, ...BULK_SUB_FIELDS];
    if(bulkThemesVisible()) {
      const mainTheme = props.themes.themes.find(theme => theme.role === 'main');
      if(mainTheme) {
        fields = [...fields, 'themes', `theme.${mainTheme.shopify_id}`];
      }
    }
    return fields;
  };

  const isAllFieldsSelected = allSelectableFields().every(field => bulkSelectedFields.includes(field));

  const handleToggleAllFields = () => {
    // Clearing takes every theme with it, not only the main one the select-all adds, so the
    // checkbox does not come back indeterminate from a theme the merchant picked by hand.
    const newSelectedFields = isAllFieldsSelected
      ? bulkSelectedFields.filter(id =>
          !allSelectableFields().includes(id) && id !== 'themes' && id.indexOf('theme.') !== 0)
      : [...new Set([...bulkSelectedFields, ...allSelectableFields()])];

    setBulkSelectedFields(newSelectedFields);
    setTotalWordCount(0);
    setCountProgress(0);
  };

  const handleThemeSelectAll = (event) => {
    let newSelectedFields = [...bulkSelectedFields];
    props.themes.themes.forEach((theme) => {
      if(!newSelectedFields.includes(`theme.${theme.shopify_id}`)) {
        newSelectedFields.push(`theme.${theme.shopify_id}`);
      }
    });
    newSelectedFields.push(`themes`);
    setBulkSelectedFields(newSelectedFields);
    
    event.stopPropagation();
  };
  const handleThemeSelectNone = (event) => {
    let newSelectedFields = bulkSelectedFields.filter(id => id.indexOf('theme.') !== 0 && id !== 'themes');
    setBulkSelectedFields(newSelectedFields);
    
    event.stopPropagation();
  };

  const renderFieldSelection = () => {
    //console.log(bulkSelectedFields.includes('products'))
    const isAllSelected = bulkSelectedFields.filter(x => x.indexOf('theme.') === 0).length === props.themes.themes.length;
    const isNoneSelected = bulkSelectedFields.filter(x => x.indexOf('theme.') === 0).length === 0;

    return <TreeView
       sx={styles2.sectionTree}
       // products stays open, no folding: the subsections are options, not a subtree to browse
       slots={{ collapseIcon: () => null, expandIcon: () => null, endIcon: () => null }}
       onSelectedItemsChange={handleSelectBulkField}
       expandedItems={['products']}
       selectedItems={bulkSelectedFields}
       multiSelect
     >
      <StyledTreeItem itemId="products" label={t('bulkTranslationFeature.settingsDialog.products')} checked={bulkSelectedFields.includes('products') ? true : false}>
        <StyledTreeItem itemId="products.variants" label={t('bulkTranslationFeature.settingsDialog.variants')} checked={bulkSelectedFields.includes('products.variants') ? true : false} disabled={!bulkSelectedFields.includes('products') ? true : false} />
        <StyledTreeItem itemId="products.options" label={t('bulkTranslationFeature.settingsDialog.options')} checked={bulkSelectedFields.includes('products.options') ? true : false} disabled={!bulkSelectedFields.includes('products') ? true : false} />
        {/*<StyledTreeItem itemId="products.metafields" label="Metafields" checked={bulkSelectedFields.includes('products.metafields') ? true : false} disabled={(props.products.sync_products_pending || !bulkSelectedFields.includes('products')) ? true : false} />*/}
      </StyledTreeItem>
      <StyledTreeItem itemId="collections" label={t('bulkTranslationFeature.settingsDialog.collections')} checked={bulkSelectedFields.includes('collections') ? true : false} sx={{ breakAfter: 'column' }}>
        {/*<StyledTreeItem itemId="collections.metafields" label="Metafields" checked={bulkSelectedFields.includes('collections.metafields') ? true : false} disabled={props.collections.sync_collections_pending || !bulkSelectedFields.includes('collections') ? true : false} />*/}
      </StyledTreeItem>
      <StyledTreeItem itemId="pages" label={t('bulkTranslationFeature.settingsDialog.pages')} checked={bulkSelectedFields.includes('pages') ? true : false}>
        {/*<StyledTreeItem itemId="pages.metafields" label="Metafields" checked={bulkSelectedFields.includes('pages.metafields') ? true : false} disabled={props.pages.sync_pages_pending || !bulkSelectedFields.includes('pages') ? true : false} />*/}
      </StyledTreeItem>
      <StyledTreeItem itemId="navigation" label={t('bulkTranslationFeature.settingsDialog.navigation')} checked={bulkSelectedFields.includes('navigation') ? true : false} />
      <StyledTreeItem itemId="blogs" label={t('bulkTranslationFeature.settingsDialog.blogs')} checked={bulkSelectedFields.includes('blogs') ? true : false}>
        {/*<StyledTreeItem itemId="blogs.metafields" label="Metafields" checked={bulkSelectedFields.includes('blogs.metafields') ? true : false} disabled={props.blogs.sync_blogs_pending || !bulkSelectedFields.includes('blogs') ? true : false} />*/}
      </StyledTreeItem>
      <StyledTreeItem itemId="articles" label={t('bulkTranslationFeature.settingsDialog.articles')} checked={bulkSelectedFields.includes('articles') ? true : false}>
        {/*<StyledTreeItem itemId="articles.metafields" label="Metafields" checked={bulkSelectedFields.includes('articles.metafields') ? true : false} disabled={props.articles.sync_articles_pending || !bulkSelectedFields.includes('articles') ? true : false} />*/}
      </StyledTreeItem>
      {bulkThemesVisible() &&
      <StyledTreeItem
        itemId="themes"
        // its own row under the two columns, the select needs the width
        sx={{ columnSpan: 'all' }}
        checked={bulkSelectedFields.includes('themes') ? true : false}
        label={
        <div style={{display: 'flex', alignItems: 'center', gap: 8, minWidth: 0}}>
          <span style={{flexShrink: 0}}>{t('bulkTranslationFeature.settingsDialog.themes')}</span>
          {/* StyledTreeItem turns pointer events off across the whole label so the row itself
              takes the click, so this has to switch them back on. And neither the click nor the
              keys may reach the row from in here: a click would toggle Themes, and the arrow
              keys would walk the tree instead of opening the menu. */}
          <div
            // top: the select's text sits 4px below its box centre, this lifts it level with "Themes"
            style={{margin: '4px 0', position: 'relative', top: -4, flex: 1, minWidth: 0, pointerEvents: 'auto'}}
            onClick={(e) => e.stopPropagation()}
            onKeyDown={(e) => e.stopPropagation()}
          >
          <FormControl variant="standard" size="small" fullWidth>
            <Select
              variant="standard"
              // the theme's bottom margin levels selects with text fields; here it would drop the
              // select below the "Themes" label
              sx={{ '&.MuiInput-root': { marginBottom: 0 } }}
              value={bulkSelectedFields}
              onChange={handleThemeSelect}
              onOpen={handleThemeSelectOpen}
              renderValue={(selected) => {
                let selectedThemesNum = bulkSelectedFields.filter(x => x.indexOf('theme.') === 0).length;
                if (selectedThemesNum > 0) {
                  return t('bulkTranslationFeature.settingsDialog.themesSelected', {count: selectedThemesNum})
                }
                return <em>{t('bulkTranslationFeature.settingsDialog.selectThemePlaceholder')}</em>;
              }}
              inputProps={{
                ref: selectRef,
              }}
              MenuProps={{
                PaperProps: {
                  style: {
                    width: menuWidth,
                  },
                },
                anchorOrigin: {
                  vertical: 'bottom',
                  horizontal: 'center',
                },
                transformOrigin: {
                  vertical: 'top',
                  horizontal: 'center',
                },
                getContentAnchorEl: null
              }}
              multiple
              displayEmpty
              disabledItemsFocusable={true}
              autoFocusItem={false}
            >
              <li style={{padding: '0 16px 8px 16px'}}>
                <Typography sx={styles2.linkBtn} onClick={handleThemeSelectAll} size="small" variant="link" style={{ opacity: isAllSelected ? .5 : 1 }}>{t('bulkTranslationFeature.settingsDialog.selectAll')}</Typography>
                <Typography sx={styles2.linkBtn} onClick={handleThemeSelectNone} size="small" variant="link" style={{ opacity: isNoneSelected ? .5 : 1 }}>{t('bulkTranslationFeature.settingsDialog.selectNone')}</Typography>
              </li>
              {props.themes.themes.map((theme) => {
                //return <StyledTreeItem itemId={`theme.${theme.shopify_id}`} label={`"${theme.name}"`} checked={bulkSelectedFields.includes(`theme.${theme.shopify_id}`) ? true : false} disabled={!bulkSelectedFields.includes('themes') ? true : false} />
                return <MenuItem 
                  key={`theme.${theme.shopify_id}`} 
                  value={`theme.${theme.shopify_id}`} 
                >
                  <Checkbox 
                    checked={bulkSelectedFields.includes(`theme.${theme.shopify_id}`)}
                    disabled={props.disabled}
                    style={{ padding: 4 }}
                  />
                  <span style={{ fontWeight: theme.role === 'main' ? 600 : 'inherit' }}>{theme.name}</span>
                  {theme.role === 'main' &&
                    <React.Fragment>&nbsp;<Typography variant="caption" sx={{ color: 'text.secondary' }}>{t('bulkTranslationFeature.settingsDialog.mainThemeLabel')}</Typography></React.Fragment>
                  }
                  &nbsp;<small>{theme.updated_at}</small>
                </MenuItem>
                })
              }
            </Select>
          </FormControl>
          </div>
        </div>
        }
      />
      }
     </TreeView>
   }

   // One target language per run: the array in the store is a leftover of the multi-select this
   // once was and everything downstream still reads it, so the select maps to and from one entry.
   // Legend above, control below - the same shape as the fields and outdated blocks that follow
   const renderBulkLanguagesSelection = () => {
    const selected = bulkSelectedLanguages[0] || '';
    const selectedLanguage = props.languages.languages.find(x => x.code === selected);
    // the select keeps a 9px bottom margin for its footprint next to text fields; here it would
    // only widen the gap to the divider, so the block takes it back
    return <FormControl component="fieldset" sx={{ ...styles2.formControl, marginBottom: '-9px' }} fullWidth>
      <FormLabel component="legend" focused={false} sx={styles2.blockLegend}>
        {t('bulkTranslationFeature.settingsDialog.step1.languageSelectLabel', 'Target language')}
      </FormLabel>
      {/* a lead-in on the row, like the "Themes" label ahead of the theme select in the tree */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
      <Typography component="span">{t('bulkTranslationFeature.settingsDialog.step1.languageSelectPrefix', 'Translate into')}</Typography>
      <Select
        id="bulk-target-language"
        variant="standard"
        displayEmpty
        disabled={restoringSelection}
        value={selected}
        onChange={handleSelectBulkLanguages}
        renderValue={() => selectedLanguage
          ? selectedLanguage.name
          : <em>{t('bulkTranslationFeature.settingsDialog.step1.languageSelectPlaceholder')}</em>}
        // the row's width like the theme select below
        sx={{ flex: 1, minWidth: 0 }}
        MenuProps={{
          classes: {
            paper: styles2.menuPaper
          },
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "left"
          },
          transformOrigin: {
            vertical: "top",
            horizontal: "left"
          },
        }}
      >
        {props.languages.languages.map((language) => {
          if(language.base === true || language.removed_on_shopify === true) {
            return null;
          }
          return (
            <MenuItem key={language.id} value={language.code}>
              {language.name}
            </MenuItem>
          )}
        )}
      </Select>
      {restoringSelection && <CircularProgress size={16} />}
      </Box>
    </FormControl>
   }

   const renderStepperActionsContainer = () => {
      return <div style={{ marginTop: 24, marginBottom: 32 }}>
        {cancelError && activeStep === STEP_RUN && isAiBulk &&
          <Alert severity="error" sx={{ mb: 2 }}>
            {t('bulkTranslationFeature.settingsDialog.cancelFailed')}
          </Alert>
        }
        {startError && activeStep === STEP_RUN && isAiBulk &&
          <Alert severity="error" sx={{ mb: 2 }}>
            {t('bulkTranslationFeature.settingsDialog.startFailed', 'The AI translation could not be started. Please try again.')}
          </Alert>
        }
        <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 8, justifyContent: 'flex-start' }}>
          {(countWordsPending || Object.keys(countTasks).length > 0) && activeStep !== STEP_TRANSLATE ?
            <Button
              disabled={cancelCounting ||
                        (activeStep === STEP_CONFIG && !hasRunConfiguration)}
              variant="outlined"
              color="error"
              onClick={clearEntireQueue}
              sx={[styles2.cancelTasksBtn, { color: "error.main", minHeight: 36.5 }]}
              startIcon={<ClearOutlinedIcon />}
            >
              {cancelCounting ? t('bulkTranslationFeature.settingsDialog.cancelBtnPending') : t('bulkTranslationFeature.settingsDialog.cancelBtn')}
              {cancelCounting && <CircularProgress size={16} color="inherit" style={{ marginLeft: 8 }} />}
            </Button>
          :
            activeStep !== STEP_TRANSLATE && !(activeStep === STEP_RUN && aiRunFinished) &&
            <Button
              // the AI flow has no count tasks to hold it back, and going back mid-run would
              // rewrite the config of a run the queue is already translating
              disabled={activeStep === STEP_CONFIG || Object.keys(countTasks).length > 0 || isSynchronizing || isTranslating || cancelCounting}
              onClick={translationCompleted ? handleBackFromFinishedRun : staleTranslateTask ? handleBackFromStaleRun : handleBackStep}
              sx={styles2.button}
              variant="outlined"
            >
              {cancelCounting ?
                <React.Fragment>
                  {t('bulkTranslationFeature.settingsDialog.cancelBtnPending')}
                  <CircularProgress size={16} color="inherit" style={{ marginLeft: 8 }} />
                </React.Fragment>
                :
                <React.Fragment>
                  <KeyboardBackspaceIcon style={{marginRight: 4}} /> {t('bulkTranslationFeature.settingsDialog.prevBtn')}
                </React.Fragment>
              }
            </Button>
          }

          {activeStep === STEP_CONFIG &&
            <Button
              disabled={(activeStep === STEP_CONFIG && !hasRunConfiguration)}
              variant="contained"
              color="primary"
              onClick={handleNextStep}
              sx={styles2.button}
            >
              {t('bulkTranslationFeature.settingsDialog.nextBtn')}
            </Button>
          }

          {activeStep === STEP_RUN && isAiBulk &&
            (aiRunFinished ? (
              <Button
                variant="contained"
                color="primary"
                sx={styles2.button}
                startIcon={<AutoAwesomeOutlinedIcon />}
                // clears the finished run from the store too, or the next run finds it listed and
                // offers to clear it instead of starting; the selection stays for the next run
                onClick={handleBackFromFinishedRun}
              >
                {t('bulkTranslationFeature.settingsDialog.setupNewBulkBtn', 'Set up a new bulk translation')}
              </Button>
            ) : (
              <React.Fragment>
                {isTranslationRunning && !staleTranslateTask &&
                  <Button
                    disabled={cancelingRun}
                    variant="outlined"
                    color="error"
                    onClick={cancelRunningTranslation}
                    sx={[styles2.button, { color: "error.main", minHeight: 36.5 }]}
                    startIcon={<ClearOutlinedIcon />}
                  >
                    {cancelingRun ? t('bulkTranslationFeature.settingsDialog.cancelRunBtnPending') : t('bulkTranslationFeature.settingsDialog.cancelRunBtn')}
                    {cancelingRun && <CircularProgress size={16} color="inherit" style={{ marginLeft: 8 }} />}
                  </Button>
                }
                {/* a listed run that no longer runs is cleared by Back, which keeps the selection;
                    a clear button next to it would only differ by dropping the selection */}
                <Button
                  disabled={isSynchronizingSections || isTranslating || cancelCounting || staleTranslateTask !== null || !hasRunConfiguration}
                  variant="contained"
                  color="primary"
                  onClick={handleStartAiBulkTranslation}
                  sx={[styles2.button, { minHeight: 36.5 }]}
                  startIcon={<AutoAwesomeOutlinedIcon />}
                >
                  {(isSynchronizingSections || isTranslating) && !staleTranslateTask ?
                    <React.Fragment>
                      {isTranslationRunning
                        ? t('bulkTranslationFeature.settingsDialog.startBtnRunning', 'Translation running…')
                        : isTranslating
                          ? t('bulkTranslationFeature.settingsDialog.startBtnPending', 'Starting translation…')
                          // the sections sync first; the progress line counts them, the button only says so
                          : t('bulkTranslationFeature.statusDialog.synchronizing', 'Synchronizing...')}
                      <CircularProgress size={16} color="inherit" style={{ marginLeft: 8 }} />
                    </React.Fragment>
                    :
                    t('bulkTranslationFeature.settingsDialog.startAiBtn', 'Start AI translation')
                  }
                </Button>
              </React.Fragment>
            ))
          }

          {activeStep === STEP_RUN && !isAiBulk &&
            <React.Fragment>
              <Button
                disabled={isSynchronizingSections || countWordsPending || cancelCounting || !hasRunConfiguration}
                variant="contained"
                color="primary"
                onClick={handleStartCountProcess}
                sx={[styles2.button, { minHeight: 36.5 }]}
                startIcon={<PlusOneOutlinedIcon />}
              >
                {!(isSynchronizingSections || countWordsPending) ?
                  <React.Fragment>
                    {countProgress === 100 ? t('bulkTranslationFeature.settingsDialog.countBtnAgain') : t('bulkTranslationFeature.settingsDialog.countBtn')}
                  </React.Fragment>
                  :
                  <React.Fragment>
                    {isSynchronizingSections ? t('bulkTranslationFeature.statusDialog.synchronizing', 'Synchronizing...') : t('bulkTranslationFeature.settingsDialog.countBtnPending')}
                    <CircularProgress size={16} color="inherit" style={{ marginLeft: 8 }} />
                  </React.Fragment>
                }
              </Button>

              <Button
                disabled={
                  countWordsPending ||
                  (countProgress < 100) ||
                  (totalWordCount > wordsLeft) ||
                  (totalWordCount === 0 && countProgress === 100)
                }
                variant="contained"
                color="primary"
                onClick={handleNextStep}
                sx={styles2.button}
              >
                {t('bulkTranslationFeature.settingsDialog.nextBtn')}
              </Button>
            </React.Fragment>
          }

          {activeStep === STEP_TRANSLATE &&
            <React.Fragment>
              {!isTranslating && !translationCompleted && (
                <Button
                  disabled={cancelCounting}
                  variant="outlined"
                  color="error"
                  onClick={clearEntireQueue}
                  sx={[styles2.button, { color: "error.main", minHeight: 36.5 }]}
                  startIcon={<ClearOutlinedIcon />}
                >
                  {cancelCounting ? t('bulkTranslationFeature.settingsDialog.cancelBtnPending') : t('bulkTranslationFeature.settingsDialog.cancelBtn')}
                  {cancelCounting && <CircularProgress size={16} color="inherit" style={{ marginLeft: 8 }} />}
                </Button>
              )}
              {translationCompleted && !isTranslating && !abortedTranslateTask ? (
                // the run's sections are still being pulled back from Shopify; finishing now would
                // rewind the dialog and hide that progress
                <Button
                  disabled={isSynchronizingSections}
                  variant="contained"
                  color="primary"
                  sx={[styles2.button, { minHeight: 36.5 }]}
                  startIcon={<PlaylistPlayOutlinedIcon />}
                  onClick={() => { clearCurrentBulkTask(); props.bulkTranslationResetRun(); handleResetSteps(); }}
                >
                  {isSynchronizingSections ? t('bulkTranslationFeature.statusDialog.synchronizing', 'Synchronizing...') : t('bulkTranslationFeature.settingsDialog.setupNewBulkBtn', 'Set up a new bulk translation')}
                  {isSynchronizingSections && <CircularProgress size={16} color="inherit" style={{ marginLeft: 8 }} />}
                </Button>
              ) : !translationCompleted && (
                <Button
                  disabled={cancelCounting || isTranslating || staleTranslateTask !== null}
                  variant="contained"
                  color="primary"
                  sx={[styles2.button, { minHeight: 36.5 }]}
                  onClick={handleStartBulkTranslation}
                  startIcon={<PlaylistPlayOutlinedIcon />}
                >
                  {isTranslationRunning
                    ? t('bulkTranslationFeature.settingsDialog.startBtnRunning', 'Translation running…')
                    : isTranslating
                      ? t('bulkTranslationFeature.settingsDialog.startBtnPending', 'Starting translation…')
                      : t('bulkTranslationFeature.settingsDialog.startBtn')}
                  {isTranslating &&
                    <CircularProgress size={16} color="inherit" style={{ marginLeft: 8 }} />
                  }
                </Button>
              )}
            </React.Fragment>
          }
        </div>
      </div>
    }


   const renderStepper = () => {
    return <Box id="BulkTranslationsConfigurationPanel" sx={styles2.root}>
      <Typography>
        {t('bulkTranslationFeature.settingsDialog.headDescription')}
      </Typography>
      {/* what the dialog does not ask for lives on the settings page: engine, formality, fields */}
      <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
        <Trans i18nKey="bulkTranslationFeature.settingsDialog.settingsHint">
          The finer details like the formality, the translation engine and the included fields of each section (title, description, handle etc.) are configured in the
          <Link component="button" variant="body2" sx={{ verticalAlign: 'baseline' }} onClick={() => { if(props.showInModalDialog) handleClose(); props.history.push('/machinetranslation/settings'); }}>bulk translation settings</Link>.
        </Trans>
      </Typography>
      {/* the listed run was started in the other mode than the setting now says; above the
          stepper, so it shows whichever step is open */}
      {runBulkType && runBulkType !== settingBulkType &&
        <Alert severity="warning" sx={{ mt: 2 }}>
          {runBulkType === 'ai'
            ? t('bulkTranslationFeature.settingsDialog.step3.runModeAi', 'This run uses AI translation. Your setting now says machine translation (NMT), which applies to the next run.')
            : t('bulkTranslationFeature.settingsDialog.step3.runModeNmt', 'This run uses machine translation (NMT). Your setting now says AI translation, which applies to the next run.')}
        </Alert>
      }
      {/*
      <Button variant="outlined" size="small" onClick={clearEntireQueue}>Clear entire queue</Button>
      <Button variant="outlined" size="small" onClick={() => {runTasksInterval(props.bulkTranslationGetTasks, true)}}>Run Interval</Button>
      */}
      <Stepper 
        activeStep={activeStep} 
        sx={styles2.stepperRoot} 
        orientation="vertical"
      >
        <Step key={'step_2'}>
          <StepLabel>{t('bulkTranslationFeature.settingsDialog.step2.title')}</StepLabel>
          <StepContent>
            {renderBulkLanguagesSelection()}
            {/* language and contents were two steps once; the rule keeps them readable as two parts */}
            <Divider sx={styles2.divider} />

            <FormControl component="fieldset" sx={styles2.formControl} fullWidth>
              {/* the all-fields toggle rides on the heading row, set off from the tree's own checkboxes */}
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <FormLabel component="legend" focused={false} sx={(theme) => ({ ...styles2.blockLegend(theme), margin: 0, width: 'auto' })}>
                  {t('bulkTranslationFeature.settingsDialog.step2.fieldsLabel')}
                </FormLabel>
                <FormControlLabel
                  style={{marginRight: 0, marginLeft: 'auto'}}
                  // the legend's 23px line box against the label's 24px left the text half a pixel high
                  sx={{ '& .MuiFormControlLabel-label': { lineHeight: '23px' } }}
                  control={
                    <Checkbox
                      size="small"
                      // centred on the line box the box reads low next to the caps; a nudge up
                      // puts it level with the letters
                      sx={{ marginTop: '-2px' }}
                      checked={isAllFieldsSelected}
                      indeterminate={!isAllFieldsSelected && bulkSelectedFields.length > 0}
                      onChange={handleToggleAllFields}
                      name="selectAllFields"
                    />
                  }
                  label={t('bulkTranslationFeature.settingsDialog.selectAll')}
                />
              </Box>
              {renderFieldSelection()}
            </FormControl>

            <Divider sx={styles2.divider} />

            <FormControl component="fieldset" sx={styles2.formControl}>
              <FormLabel component="legend" focused={false} sx={styles2.blockLegend}>{t('bulkTranslationFeature.settingsDialog.step2.outdatedLabel')}</FormLabel>
              <Typography variant="body2" style={{margin: '8px 0'}}>
                {t('bulkTranslationFeature.settingsDialog.step2.outdatedInfo')}
              </Typography>
              <FormControlLabel
                control={<Checkbox checked={outdated} onChange={(e) => {setOutdated(!outdated)}} name="outdated" />}
                label={t('bulkTranslationFeature.settingsDialog.step2.outdatedLabel')}
              />
            </FormControl>

            {renderStepperActionsContainer()}
          </StepContent>
        </Step>

        <Step key={'step_3'}>
          <StepLabel>{isAiBulk ? t('bulkTranslationFeature.settingsDialog.step3.titleAi', 'Step 3: Start translation') : t('bulkTranslationFeature.settingsDialog.step3.title')}</StepLabel>
          <StepContent>
            <Fade in={!isAiBulk && countProgress < 100} mountOnEnter={true} unmountOnExit={true}>
              <Typography variant="body1" sx={styles2.text} gutterBottom id="alert-dialog-description">
                {t('bulkTranslationFeature.settingsDialog.step3.info1')}
              </Typography>
            </Fade>

            {isAiBulk &&
              <Typography variant="body2" color="text.secondary" gutterBottom style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
                <AutoAwesomeOutlinedIcon fontSize="small" color="primary" />
                <Chip
                  variant="outlined"
                  size="small"
                  label={t('system.beta', 'Beta')}
                  sx={{ height: 18, fontSize: 10 }}
                />
                <span>
                  {t('bulkTranslationFeature.settingsDialog.step3.aiInfo', 'Translated by AI — no words are deducted from your balance.')}
                  {' '}
                  {t('bulkTranslationFeature.settingsDialog.step3.aiNoCountInfo', 'A word count is therefore skipped.')}
                </span>
              </Typography>
            }

            {/* AI mode merges the "start" and "progress" steps: show progress / success here. */}
            {isAiBulk && (isTranslating || translationCompleted) &&
              <React.Fragment>
                <Fade in={isTranslating && !staleTranslateTask} mountOnEnter unmountOnExit>
                  <div>
                    <DialogContentText variant="body1">
                      {t('bulkTranslationFeature.statusDialog.processRunning', { translateProgress: props.bulkTranslation.translate_progress })}
                    </DialogContentText>
                    <Typography variant="body2" color="text.secondary" style={{ marginTop: 4 }}>
                    {t('bulkTranslationFeature.settingsDialog.backgroundHint', 'You can leave this page or close the browser now, the process continues in the background.')}
                  </Typography>
                  </div>
                </Fade>
                <Fade in={!isTranslating && translationCompleted && !abortedTranslateTask} mountOnEnter unmountOnExit>
                  {completionUnverified
                    ? <Typography variant="body1" sx={styles2.text} gutterBottom>
                        {t('bulkTranslationFeature.settingsDialog.step4.noRunInfo')}
                      </Typography>
                    : aiWroteNothing
                    // the section rows still carry their green "finished" chip, so a plain line
                    // would read as a successful run
                    ? <Alert severity={aiRunAllFailed ? 'warning' : 'info'} sx={{ mb: 2 }}>
                        {t(aiRunAllFailed
                          ? 'bulkTranslationFeature.settingsDialog.step4.nothingTranslated'
                          : 'bulkTranslationFeature.settingsDialog.step4.nothingToTranslate')}
                      </Alert>
                    : <Typography variant="body1" sx={styles2.text} gutterBottom>
                        {t('bulkTranslationFeature.settingsDialog.step4.translationCompleted', 'Your translation has been completed successfully!')}
                      </Typography>}
                </Fade>
              </React.Fragment>
            }

            <Fade in={isSynchronizingSections || (countWordsPending && (countProgress <= 100))} mountOnEnter={true} unmountOnExit={true}>
              <div>
                <DialogContentText variant="body1">
                  {isSynchronizingSections ?
                    synchronizingLabel(t, props.bulkTranslation)
                    : isAiBulk ?
                    t('bulkTranslationFeature.settingsDialog.aiPreparing', 'Preparing…')
                    :
                    t('bulkTranslationFeature.settingsDialog.step3.countProgressInfo', {countProgress, totalWordCount: totalWordCount.toLocaleString()})
                  }
                </DialogContentText>
                {/* Indeterminate while syncing — there is no percentage for that phase.
                    MUI runs two overlapping bars there, which is a lot of movement next to
                    the tasks list, so the second one is dropped and the sweep slowed down. */}
                <LinearProgress
                  variant={isSynchronizingSections ? 'indeterminate' : 'determinate'}
                  value={countProgress || 0}
                  sx={{
                    margin: '6px 0 4px',
                    '& .MuiLinearProgress-bar1Indeterminate': { animationDuration: '3s' },
                    '& .MuiLinearProgress-bar2Indeterminate': { display: 'none' },
                  }}
                />
                {/* the sync that runs before a count is not resumable, the count itself is */}
                {countWordsPending && !isSynchronizingSections &&
                  <Typography variant="body2" color="text.secondary" style={{ marginTop: 4 }}>
                  {t('bulkTranslationFeature.settingsDialog.backgroundHint', 'You can leave this page or close the browser now, the process continues in the background.')}
                </Typography>
                }
              </div>
            </Fade>
                
            <Fade in={isTaskQuerying} mountOnEnter={true} unmountOnExit={true}>
              <FadingTextComponent 
                texts={[
                  bulkSelectedFields.includes('products.variants') ? t('bulkTranslationFeature.settingsDialog.fetchingVariants') : null,
                  bulkSelectedFields.includes('products.options') ? t('bulkTranslationFeature.settingsDialog.fetchingOptions') : null,
                ]} 
              />
            </Fade>



            <Fade in={!isAiBulk && !countWordsPending && countProgress === 100 && (totalWordCount > wordsLeft)} mountOnEnter={true} unmountOnExit={true}>
              <div>
                <Typography gutterBottom>
                  <Trans i18nKey={'bulkTranslationFeature.settingsDialog.step3.notEnoughWordsLeft'}
                    values={{
                      totalWordCount: new Intl.NumberFormat('en-US').format(totalWordCount),
                      missingWordCount: new Intl.NumberFormat('en-US').format(totalWordCount - wordsLeft)
                    }}
                  >
                    Your selection contains <strong>{new Intl.NumberFormat('en-US').format(totalWordCount)}</strong> words, but you don't have enough words left to translate everything. Please purchase at least <strong>{() => {new Intl.NumberFormat('en-US').format(totalWordCount - wordsLeft)}}</strong> words.
                  </Trans>
                </Typography>
                {wordpack && !loading &&
                  <DialogContentText variant="body1">
                    <Trans i18nKey={'bulkTranslationFeature.settingsDialog.step3.wordpackRecommendation'}
                      values={{
                        price: wordpack.price_formatted,
                        packsize: new Intl.NumberFormat( 'en-US', { maximumFractionDigits: 1,notation: "compact" , compactDisplay: "short" }).format(wordpack.count),
                        wordpackName: wordpack.name
                      }}
                    >
                      We recommend our <strong>{wordpack.name}</strong> machine-translation wordpack with {new Intl.NumberFormat( 'en-US', { maximumFractionDigits: 1,notation: "compact" , compactDisplay: "short" }).format(wordpack.count)} words for the price of { wordpack.price_formatted }
                    </Trans>
                  </DialogContentText>
                }
                <ButtonGroup variant="outlined" color="primary"
                  size="small"
                  disabled={(!wordpack || loading)}
                  //<sx={styles2.button}
                  //style={{display: 'inline-block'}}
                  aria-label="split button">
                  <Button onClick={buyWordpack} disabled={!wordpack || loading} size="small" style={{ minHeight: 36.5 }}>
                    {(!wordpack) ?
                      t('bulkTranslationFeature.settingsDialog.buyBtn', {
                        price: '',
                        packsize: ''
                      })
                      :
                      t('bulkTranslationFeature.settingsDialog.buyBtn', {
                        price: wordpack.price_formatted,
                        packsize: new Intl.NumberFormat( 'en-US', { maximumFractionDigits: 1,notation: "compact" , compactDisplay: "short" }).format(wordpack.count)
                      })
                    }
                    {loading && <CircularProgress size={16} color="inherit" style={{ marginLeft: 8 }} />}
                  </Button>
                  <Button onClick={openRechargePlans} style={{height: 36.5}} size="small">
                    <MoreHorizIcon />
                  </Button>
                </ButtonGroup>
              </div>
            </Fade>

            <Fade in={!countWordsPending && countProgress === 100 && totalWordCount === 0} mountOnEnter={true} unmountOnExit={true}>
              <DialogContentText variant="body1">{t('bulkTranslationFeature.settingsDialog.step3.foundNoWords')}</DialogContentText>
            </Fade>

            {!countWordsPending && countProgress === 100 && (totalWordCount > 0 && totalWordCount <= wordsLeft) &&
              <DialogContentText variant="body1">
                <Trans i18nKey={'bulkTranslationFeature.settingsDialog.step3.foundWords'} totalWordCount={totalWordCount.toLocaleString()}>
                  Found <strong>{{ totalWordCount }}</strong> words to translate.
                </Trans>
              </DialogContentText>
            }

            {(props.bulkTranslation.task_errors.length > 0 && countProgress === 100) &&
              <DialogContentText variant="body1" sx={styles1.errorText}>
                <Tooltip title={showTaskErrors ? t('bulkTranslationFeature.settingsDialog.hideAllErrors') : t('bulkTranslationFeature.settingsDialog.showAllErrors')} arrow>
                  <span onClick={(e) => {e.preventDefault(); setShowTaskErrors(!showTaskErrors);}} style={{cursor: 'pointer'}}>{t('bulkTranslationFeature.settingsDialog.step3.taskErrors', {errorCount: props.bulkTranslation.task_errors.length})}</span>
                </Tooltip>
                <Collapse in={showTaskErrors}>
                  {props.bulkTranslation.task_errors.map(item => <Typography><small>{item}</small></Typography>)}
                </Collapse>
              </DialogContentText>
            }

            <TasksList type={isAiBulk ? 'translate' : 'count'} />
            {renderStepperActionsContainer()}
          </StepContent>
        </Step>

        {!isAiBulk &&
        <Step key={'step_4'}>
          <StepLabel>{t('bulkTranslationFeature.settingsDialog.step4.title')}</StepLabel>
          <StepContent>
            <React.Fragment>
              <Fade in={isTranslating} mountOnEnter unmountOnExit>
                <div>
                  <DialogContentText variant="body1">
                    {t('bulkTranslationFeature.statusDialog.processRunning', { translateProgress: props.bulkTranslation.translate_progress })}
                  </DialogContentText>
                  <LinearProgress
                    variant="determinate"
                    value={props.bulkTranslation.translate_progress || 0}
                    sx={{ margin: '6px 0 4px' }}
                  />
                  <Typography variant="body2" color="text.secondary" style={{ marginTop: 4 }}>
                  {t('bulkTranslationFeature.settingsDialog.backgroundHint', 'You can leave this page or close the browser now, the process continues in the background.')}
                </Typography>
                </div>
              </Fade>

              <Fade in={!isTranslating} mountOnEnter unmountOnExit>
                <Typography variant="body1" sx={styles2.text} gutterBottom>
                  {translationCompleted && !abortedTranslateTask
                    ? (completionUnverified
                      ? t('bulkTranslationFeature.settingsDialog.step4.noRunInfo')
                      : t('bulkTranslationFeature.settingsDialog.step4.translationCompleted', 'Your translation has been completed successfully!'))
                    : t('bulkTranslationFeature.settingsDialog.step4.successInfo')}
                </Typography>
              </Fade>

              {!isTranslating && !translationCompleted && (
                <DialogContentText variant="body1">
                  Found <strong>{totalWordCount.toLocaleString()}</strong> words to translate.
                </DialogContentText>
              )}

              {props.showSummary && <DialogContentText variant="body1" style={{ marginTop: 16 }}>
                <div
                  onClick={() => setConfigSummaryExpanded(!configSummaryExpanded)}
                  style={{
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    marginBottom: 8
                  }}
                >
                  <IconButton size="small" style={{ marginRight: 4 }}>
                    {configSummaryExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                  </IconButton>
                  <strong>{t('bulkTranslationFeature.configurationSummary')}</strong>
                </div>
                <Collapse in={configSummaryExpanded}>
                  <div>
                    <strong>{t('bulkTranslationFeature.targetLanguages')}</strong>{' '}
                    {bulkSelectedLanguages.map(code => {
                      const lang = props.languages.languages.find(l => l.code === code);
                      return lang ? lang.name : code;
                    }).join(', ')}
                    <br />
                    <strong>{t('bulkTranslationFeature.includedSections')}</strong>
                    <ul style={{ marginTop: 8, marginBottom: 8, paddingLeft: 20 }}>
                      {bulkSelectedFields
                        .filter(field => !field.startsWith('theme.')) // Filter out individual theme items
                        .map((field, index) => {
                          // Handle 'themes' parent - show with nested list of individual themes
                          if (field === 'themes') {
                            const themeItems = bulkSelectedFields.filter(f => f.startsWith('theme.'));
                            return (
                              <li key={index}>
                                {t('bulkTranslationFeature.settingsDialog.themes')}
                                {themeItems.length > 0 && (
                                  <ul style={{ marginTop: 4, marginBottom: 4, paddingLeft: 20 }}>
                                    {themeItems.map((themeField, themeIndex) => {
                                      const themeId = themeField.split('.')[1];
                                      const theme = props.themes.themes.find(t => String(t.shopify_id) === String(themeId));
                                      if (theme) {
                                        return (
                                          <li key={themeIndex}>
                                            {theme.name} <small>({theme.updated_at})</small>
                                          </li>
                                        );
                                      }
                                      return <li key={themeIndex}>{t('bulkTranslationFeature.themeNotFound', { themeId })}</li>;
                                    })}
                                  </ul>
                                )}
                              </li>
                            );
                          }
                          if (BULK_SUB_FIELD_LABELS[field]) {
                            return <li key={index}>{t(BULK_SUB_FIELD_LABELS[field])}</li>;
                          }
                          // Handle regular sections - check if translation exists
                          const translationKey = `bulkTranslationFeature.settingsDialog.${field}`;
                          const translatedText = t(translationKey);
                          // If translation doesn't exist, it returns the key itself, so check for that
                          if (translatedText === translationKey) {
                            return <li key={index}>{field}</li>;
                          }
                          return <li key={index}>{translatedText}</li>;
                        })}
                    </ul>
                    <strong>{t('bulkTranslationFeature.settingsDialog.step2.outdatedLabel')}:</strong>{' '}
                    {outdated ? 'Yes' : 'No'}
                  </div>
                </Collapse>
              </DialogContentText>}
            </React.Fragment>
            <TasksList type="translate" />
            {renderStepperActionsContainer()}
          </StepContent>
        </Step>
        }
      </Stepper>

      <RechargePlans
        visible={showRechargePlans}
        //wordNeeded={(totalWordCount > wordsLeft) ? totalWordCount - wordsLeft : 0}
        wordNeeded={10000}
        onClose={closeRechargePlans}
        onBuy={onBuyWords}
      />
    </Box>
   }
   
   return <React.Fragment>
    {props.showInModalDialog ?
      <React.Fragment>

        {!props.hideButton && (
          hasBulkTranslationAccess(props.shop.shop.charge?.name, props.shop.shop.langify_features) ?
            <Button
              variant="contained"
              color="primary"
              onClick={() => props.history.push('/machinetranslation/bulk')}
            >
              <HorizontalSplitRoundedIcon style={{marginRight: 8}} /> {t('bulkTranslationFeature.settingsDialog.title')}
            </Button>
          :
            <div style={{ position: 'relative' }}>
              <Button
                variant="contained"
                color="primary"
                disabled={true}
                style={{paddingRight: 80}}
              >
                {t('bulkTranslationFeature.settingsDialog.title')}
              </Button>
              <UpgradePlanHint
                title={t('bulkTranslationFeature.settingsDialog.planUpdateNeeded')}
                features={[
                  t('bulkTranslationFeature.settingsDialog.bulkTranslateEntireSections'),
                ]}
                placement={'bottom'}
                neededPlan={'growth'}
                position="end"
                isOverlay
                isBlock
              />
            </div>
        )}

        {/* Only render Dialog if not buttonOnly mode */}
        {props.buttonOnly ? null : (

        <Dialog
          id="bulkTranslationSetup"
          open={open}
          onClose={handleClose}
          title={t('bulkTranslationFeature.settingsDialog.title')}
          titleIcon={<HorizontalSplitRoundedIcon />}
          subtitle={countWordsPending ? `Counting: ${countProgress}%` : null}
          progress={countProgress}
          showProgress={countWordsPending}
          disableClose={countWordsPending}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          hideBackdrop={isMinimized}
          disableEnforceFocus={isMinimized}
          disableAutoFocus={isMinimized}
          disableScrollLock={isMinimized}
          disableRestoreFocus={isMinimized}
          style={isMinimized ? { pointerEvents: 'none' } : {}}
          BackdropProps={{
            style: {
              backgroundColor: isMinimized ? 'transparent' : 'rgba(255, 255, 255, .5)',
              pointerEvents: isMinimized ? 'none' : 'auto'
            },
            invisible: isMinimized
          }}
          PaperProps={{
            style: isMinimized ? {
              position: 'fixed',
              bottom: 0,
              right: 12,
              margin: 0,
              maxWidth: 400,
              minWidth: Math.min(350, window.innerWidth - 24),
              width: 'auto',
              pointerEvents: 'auto'
            } : {}
          }}
        >
          <DialogTitle id="alert-dialog-title" style={{padding: isMinimized ? '8px 24px' : '16px 24px'}}>
            <HorizontalSplitRoundedIcon style={{marginRight: 8}} /> {t('bulkTranslationFeature.settingsDialog.title')}
          </DialogTitle>
            <IconButton aria-label="minimize" style={{position: 'absolute', right: 48, top: isMinimized ? 0 : 8}} onClick={() => setIsMinimized(!isMinimized)}>
              {isMinimized ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </IconButton>
            <IconButton aria-label="close" sx={styles2.closeButton} style={{top: isMinimized ? 0 : 8}} onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          {isMinimized && (countWordsPending || countProgress > 0) && (
            <DialogContent style={{ paddingTop: isMinimized ? 0 : 8, paddingBottom: 12 }}>
              <LinearProgress variant="determinate" value={countProgress} style={{ margin: '0 -24px 8px -24px' }} />
              <Typography variant="body2">
                {isSynchronizingSections ?
                  synchronizingLabel(t, props.bulkTranslation)
                  :
                  t('bulkTranslationFeature.settingsDialog.step3.countProgressInfo', {countProgress, totalWordCount: totalWordCount.toLocaleString()})
                }
              </Typography>
            </DialogContent>
          )}
          {!isMinimized && (
            <DialogContent>
              {renderStepper()}
            </DialogContent>
          )}
        </Dialog>
        )}
      </React.Fragment>
    :
      renderStepper()
    }
  </React.Fragment>
 }
 const styles2 = {
  badge: {
    backgroundColor: 'accentSurface.background',
    color: 'accentSurface.text',
    padding: '4px 8px',
    transform: 'scale(1) translate(100%, -25%)',
  },
  root: {
    width: '100%',
  },
  sectionTree: {
    width: '100%',
    // two columns: the break after Collections fixes the split, Themes spans both below
    columnCount: 2,
    columnGap: 2,
    '& > li': { breakInside: 'avoid' },
  },
  stepperRoot: {
    padding: '24px 0',
  },
  button: {
    margin: 0,
  },
  actionsContainer: {
    marginTop: 24,
    marginBottom: 32,
    marginLeft: -4,
  },
  resetContainer: {
    padding: 24,
  },
  menuPaper: {
    maxHeight: 225,
  },
  errorText: (theme) => ({
    color: `${theme.palette.error.main} !important`,
  }),
  loadingSign: {
    position: 'relative',
    margin: 4,
  },
  loadingSpinnerContainer: {
    margin: 'auto',
    top: 1,
    position: 'absolute',
  },
  divider: {
    margin: '18px 0',
  },
  // the three blocks of the configuration step share one heading style
  // dark mode: primary.main is too dim on the dialog's paper, the link tone stays readable
  blockLegend: (theme) => ({
    margin: '0 0 8px',
    color: theme.palette.mode === 'dark' ? theme.palette.link : theme.palette.primary.main,
  }),
  formControl: {
    //marginBottom: 12
  },
  formControlLabel: {
    width: '100%',
  },
  closeButton: {
    position: 'absolute',
    right: 8,
    top: 8,
    color: 'grey.500',
  },
  rotateIcon: {
    animation: 'spin 2s linear infinite',
    '@keyframes spin': {
      '0%': { transform: 'rotate(360deg)' },
      '100%': { transform: 'rotate(0deg)' },
    },
  },
  bulkSelectedFieldsTooltipPopper: {
    zIndex: '100000 !important',
    marginTop: -40,
  },
  cancelTasksBtn: {
    margin: 0,
    /*
    borderColor: 'red',
    color: 'red',
    '&:hover': {
      backgroundColor: 'red',
      color: 'white',
    }
    */
  },
  themeSelectRoot: {
    marginLeft: -30,
    paddingRight: 8,
  },
  linkBtn: {
    margin: '4px 8px',
    cursor: 'pointer',
    textDecoration: 'underline',
  },
};
const mapStateToProps2 = ({ shop, themes, stats, bulkTranslation, languages, products, collections, pages, navigation, blogs, articles, notifications, config }) => ({
  shop,
  themes,
  languages,
  stats: stats,
  editTheme: themes.edit_theme,
  editLanguage: shop.shop.edit_language,
  shopUrl: shop.shop.url,
  bulkTranslation,
  bulkSettingsData: config.bulk_settings_data,
  products,
  collections,
  pages,
  navigation,
  blogs,
  articles,
  notifications
});
const mapDispatchToProps2 = dispatch =>
  bindActionCreators(
    {
      prepareCountWords,
      bulkCountWords,
      bulkTranslationStart,
      bulkTranslateDirect,
      bulkTranslationGetTasks,
      bulkTranslationClearTasks,
      bulkTranslationResetRun,
      syncProducts,
      syncCollections,
      syncPages,
      syncNavigation,
      syncBlogs,
      syncArticles,
      bulkTranslationSetSynchronizing,
      getBulkSettings,
      bulkTranslationSectionSynchronized,
    },
    dispatch
  )
export const BulkTranslationSettings = withRouter(connect(
  mapStateToProps2,
  mapDispatchToProps2
)(withTranslation()(BulkTranslationSettingsComponent)));

// Row fill of the tasks list, read off the total progress bar above it: its track colour
// while a section runs, its bar colour once the section is done. Both modes are the bar's
// own values, so the rows and the bar always match.
const ROW_FILL_COLORS = {
  light: 'rgb(238, 236, 251)',
  dark: 'rgb(35, 32, 50)',
};
// The chip of a finished row sits on the fill, not on the page surface, so the infoBar
// green goes in opaque per mode — the dark token is translucent (rgba(51, 105, 30, 0.25))
// and would blend with the violet underneath into olive. rgb(35, 49, 30) is that token
// flattened over background.paper, so the chip looks the same as everywhere else.
const ROW_DONE_CHIP_COLORS = {
  light: { backgroundColor: '#f1f8e9', color: '#33691e' },
  dark: { backgroundColor: 'rgb(35, 49, 30)', color: '#aed581' },
};

// detail_count keys of bulk_translation/running_tasks are the backend's job types,
// not the UI section names (navigation -> navigations, variants -> option_value).
// Sum every alias so a row with several job types still shows one counter.
const DETAIL_COUNT_ALIASES = {
  navigation: ['navigations'],
  themes: ['themes', 'theme', 'online_store_theme'],
  variants: ['option_value'],
};

const sumDetailCount = (detail, rawKey) => {
  if (!detail || !rawKey) return undefined;
  let sum;
  for (const key of DETAIL_COUNT_ALIASES[rawKey] || [rawKey]) {
    if (typeof detail[key] === 'number') sum = (sum ?? 0) + detail[key];
  }
  return sum;
};

/**
 * +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
 * TasksList Component
 * +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
 *
 * Displays tasks from bulkTranslation.tasks as a flat list with alternating row backgrounds.
 * Each section within a task key (ARTICLES, BLOGS, …) becomes its own list item.
 *
 * Props:
 *   dense {bool} — render a compact version (reduced padding, condensed layout)
 *   type  {string} — only show tasks of this type ('count' / 'translate'); all types when unset
 */
export function TasksList({ dense = false, type = null }) {
  const { t } = useTranslation();
  const theme = useTheme();
  const tasks = useSelector((state) => state.bulkTranslation.tasks);
  // a step shows its own phase only: the finished count of this run is still listed while the
  // translate step opens, and reads as that step's own state until the first poll lands
  const entries = Object.entries(tasks || {}).filter(([, task]) => !type || task?.type === type);
  const isDark = theme.palette.mode === 'dark';

  // Expand every task into one row per section/sub_object so even/odd applies to the flat list
  const rows = React.useMemo(() => {
    const result = [];
    for (const [key, task] of entries) {
      const { scope } = taskKey2DataObject(key);
      const sections = scope.split(',');
      const detailCreator = task.detail_count?.creator;
      const detailWorker = task.detail_count?.worker;
      const subObjects = task.parameter?.sub_objects
        ? task.parameter.sub_objects.split(',').filter(Boolean)
        : [];
      for (const section of sections) {
        const label = section === 'none' ? 'THEMES' : section.toUpperCase();
        result.push({ label, detailCreator, detailWorker, taskKey: key, taskStatus: task.status, isSub: false });
        // Insert sub-objects directly after their parent section
        for (const sub of subObjects) {
          if (sub.split('.')[0] === section) {
            const detailKey = sub.split('.').pop();
            result.push({ label: sub, detailCreator, detailWorker, detailKey, taskKey: key, taskStatus: task.status, isSub: true });
          }
        }
      }
    }
    return result;
  }, [tasks, type]); // eslint-disable-line

  if (rows.length === 0) return null;

  return (
    <div>
      <Typography variant="caption" sx={{ display: 'block', padding: '4px 12px', fontWeight: 600, color: 'text.secondary', textTransform: 'uppercase', letterSpacing: 1, borderBottom: '1px solid', borderColor: 'divider' }}>
        {t('bulkTranslationFeature.tasksTitle')}
      </Typography>
      {rows.map(({ label, detailCreator, detailWorker, detailKey, taskKey, taskStatus, isSub }, index) => {
        const rawKey = isSub ? detailKey : label.toLowerCase();
        const jobsCreated = sumDetailCount(detailCreator, rawKey);
        const jobsDone = sumDetailCount(detailWorker, rawKey);
        const indent = isSub ? 16 : 0;

        const workersDone = jobsDone ?? 0;
        // Each row doubles as its own progress bar: a gradient fill that grows with the
        // finished jobs. A finished section is simply the same fill at full width.
        const progress = jobsCreated > 0 ? Math.min(100, Math.round((workersDone / jobsCreated) * 100)) : null;
        // The fill is light in light mode and dark in dark mode, so the row's own text
        // colour keeps working over it.
        // A gradient stop cannot be animated, so every poll snapped the fill to its new position.
        // An overlay whose width transitions fills up like the determinate bar above the list,
        // and it is kept at zero width so the first advance grows out of nothing.
        const rowFill = (theme) => {
          if (progress === null) return {};
          const fill = ROW_FILL_COLORS[theme.palette.mode] || ROW_FILL_COLORS.light;
          return {
            position: 'relative',
            '&::before': {
              content: '""',
              position: 'absolute',
              top: 0,
              bottom: 0,
              left: 0,
              width: `${progress}%`,
              backgroundColor: fill,
              // the same duration and easing MUI gives LinearProgress
              transition: 'width .4s linear',
              pointerEvents: 'none',
            },
            // the row's own content has to stay above the overlay
            '& > *': { position: 'relative' },
          };
        };
        // Fall back to task-level status when no detail counts exist for this section
        const statusChip = ABORTED_TASK_STATES.includes(taskStatus)
          ? <Chip label={t(taskStatus === 'cancelled' || taskStatus === 'canceled' ? 'bulkTranslationFeature.statusCancelled' : 'bulkTranslationFeature.statusFailed')} size="small" sx={{ height: 16, fontSize: 10, backgroundColor: 'errorBar.background', color: 'errorBar.text' }} />
          : jobsCreated != null
          ? (workersDone === 0
            ? <Chip label={t('bulkTranslationFeature.statusPending')} size="small" sx={{ height: 16, fontSize: 10, backgroundColor: 'action.selected' }} />
            : workersDone < jobsCreated
              ? <Chip label={t('bulkTranslationFeature.statusInProcess')} size="small" sx={{ height: 16, fontSize: 10, backgroundColor: 'warningBar.background', color: 'warningBar.text' }} />
              : <Chip label={t('bulkTranslationFeature.statusFinished')} size="small" sx={{ height: 16, fontSize: 10, ...(isDark ? ROW_DONE_CHIP_COLORS.dark : ROW_DONE_CHIP_COLORS.light) }} />)
          : taskStatus === 'running'
            ? <Chip label={t('bulkTranslationFeature.statusInProcess')} size="small" sx={{ height: 16, fontSize: 10, backgroundColor: 'warningBar.background', color: 'warningBar.text' }} />
            : taskStatus === 'completed'
              ? <Chip label={t('bulkTranslationFeature.statusFinished')} size="small" sx={{ height: 16, fontSize: 10, backgroundColor: 'infoBar.background', color: 'infoBar.text' }} />
              : <Chip label={t('bulkTranslationFeature.statusPending')} size="small" sx={{ height: 16, fontSize: 10, backgroundColor: 'action.selected' }} />;

        if (dense) {
          return (
            <Box
              key={`${taskKey}-${label}`}
              sx={(theme) => ({ ...rowFill(theme), padding: '3px 8px', paddingLeft: `${8 + indent}px`, borderBottom: '1px solid', borderColor: 'divider', display: 'flex', alignItems: 'center', gap: 0.75 })}
            >
              {isSub && <Typography variant="caption" sx={{ color: 'text.disabled', marginRight: '-2px' }}>↳</Typography>}
              <Typography variant="caption" style={{ fontWeight: isSub ? 400 : 600, flex: 1 }}>
                {label}
              </Typography>
              {jobsCreated != null && (
                <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                  {t('bulkTranslationFeature.jobsCount', { done: workersDone, total: jobsCreated })}
                </Typography>
              )}
              {statusChip}
            </Box>
          );
        }

        return (
          <Box
            key={`${taskKey}-${label}`}
            sx={(theme) => ({ ...rowFill(theme), padding: '6px 12px', paddingLeft: `${12 + indent}px`, borderBottom: '1px solid', borderColor: 'divider' })}
          >
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                {isSub && <Typography variant="caption" sx={{ color: 'text.disabled' }}>↳</Typography>}
                <Typography variant="body2" style={{ fontWeight: isSub ? 400 : 600 }}>
                  {label}
                </Typography>
                {statusChip}
              </div>
              {jobsCreated != null && (
                <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 500 }}>
                  {t('bulkTranslationFeature.jobsCount', { done: workersDone, total: jobsCreated })}
                </Typography>
              )}
            </div>
          </Box>
        );
      })}
    </div>
  );
}


/**
 * +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
 * Bulk Translation Status Card Component
 * +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
 * 
 * Durch alle session storage entries durchiterieren und alle entries mit "ly_bulk_translate:" im Namen sammeln.
 * "ly_bulk_translate:<SHOP URL>:<TARGET LANGUAGE>_<SCOPE>" Prefix aus den Namen der gefundenen Entries entfernen und den rest bei '_' splitten damit man an die entsprechende editLanguage sowie den Scope gelangt
 * 
 * 
 * 
 */
function BulkTranslationStatusCardComponent(props) {
  const { t } = useTranslation();
  const languages = props.languages.languages;


  const [showCard, setShowCard] = useState(false);
  const [showTaskErrors, setShowTaskErrors] = useState(false);
  const [translateProgress, setTranslateProgress] = useState(props.bulkTranslation.translate_progress);
  const [translateWordsPending, setTranslateWordsPending] = useState(props.bulkTranslation.translate_words_pending);
  const [allTranslateJobsCount, setAllTranslateJobsCount] = useState(props.bulkTranslation.all_translate_jobs_count);
  const [allTranslateJobsDone, setAllTranslateJobsDone] = useState(props.bulkTranslation.all_translate_jobs_done);
  const [isSyncing, setIsSyncing] = useState(false);
  const [hasAutoSynced, setHasAutoSynced] = useState(false);
  const [isMinimized, setIsMinimized] = useState(false);
  const [isTranslationComplete, setIsTranslationComplete] = useState(false);
  // Track sections that need to be synced (derived from translate_tasks)
  const [pendingSyncs, setPendingSyncs] = useState([]);
  const [syncTotal, setSyncTotal] = useState(0);
  const [syncDone, setSyncDone] = useState(0);
  const pendingSyncsCountRef = useRef(0);

  // Count task related state
  const [countProgress, setCountProgress] = useState(props.bulkTranslation.count_progress);
  const [countWordsPending, setCountWordsPending] = useState(props.bulkTranslation.count_words_pending);
  const [totalWordCount, setTotalWordCount] = useState(props.bulkTranslation.total_words);
  const [wordsLeft, setWordsLeft] = useState(props.shop.shop.auto_translations?.available_words || 0);
  const [hasCountTasks, setHasCountTasks] = useState(false);
  const isCancelingRef = useRef(false);

  // Wordpack state
  const [wordpack, setWordpack] = useState(null);
  const [wordpackLoading, setWordpackLoading] = useState(false);

  // Derive sections to sync from translate_tasks
  const getSectionsToSync = deriveSectionsToSyncFromTasks;

  // Initial mount - check for running tasks (count or translate)
  useEffect(() => {
    props.bulkTranslationGetTasks((res) => {
      if (res.tasks && Object.keys(res.tasks).length > 0) {
        let hasRunningCountTask = false;
        let hasCompletedCountTask = false;
        let hasRunningTranslateTask = false;
        let hasCompletedTranslateTask = false;

        for (const task of Object.values(res.tasks)) {
          if (task.type === 'count') {
            setHasCountTasks(true);
            if (task.status === 'running') {
              hasRunningCountTask = true;
            }
            if (task.status === 'completed') {
              hasCompletedCountTask = true;
            }
          }
          if (task.type === 'translate') {
            if (task.status === 'running') {
              hasRunningTranslateTask = true;
            }
            if (task.status === 'completed') {
              hasCompletedTranslateTask = true;
            }
          }
        }

        // Start interval and show card for running count tasks
        if (hasRunningCountTask) {
          runTasksInterval(props.bulkTranslationGetTasks);
          setShowCard(true);
        }

        // Show card for completed count tasks (ready to translate)
        if (hasCompletedCountTask) {
          setShowCard(true);
        }

        // Start interval and show card for running translate tasks
        if (hasRunningTranslateTask) {
          runTasksInterval(props.bulkTranslationGetTasks);
          setHasAutoSynced(false);
          setShowCard(true);
        }

        // Show card for completed translate tasks (needs sync)
        if (hasCompletedTranslateTask) {
          setShowCard(true);
        }
      }
    });

    return () => {
      // No cleanup needed - interval persists globally
    };
  }, []);

  // Handle count progress updates
  useEffect(() => {
    if (props.bulkTranslation.count_progress !== countProgress) {
      setCountProgress(props.bulkTranslation.count_progress);
    }
    if (props.bulkTranslation.count_words_pending !== countWordsPending) {
      setCountWordsPending(props.bulkTranslation.count_words_pending);
    }
    if (props.bulkTranslation.total_words !== totalWordCount) {
      setTotalWordCount(props.bulkTranslation.total_words);
    }
    if (props.shop.shop.auto_translations?.available_words !== wordsLeft) {
      setWordsLeft(props.shop.shop.auto_translations?.available_words || 0);
    }

    // Check if there are count tasks
    const countTasksExist = Object.keys(props.bulkTranslation.count_tasks || {}).length > 0;
    setHasCountTasks(countTasksExist);

    // Show card when counting is pending or has results
    if (!isCancelingRef.current && (props.bulkTranslation.count_words_pending || countTasksExist)) {
      setShowCard(true);
    }
  }, [
    props.bulkTranslation.count_progress,
    props.bulkTranslation.count_words_pending,
    props.bulkTranslation.total_words,
    props.bulkTranslation.count_tasks,
    props.shop.shop.auto_translations?.available_words
  ]);

  // Show card when pre-count synchronization starts, word count is being prepared, or counting is pending
  useEffect(() => {
    if (!isCancelingRef.current && (props.bulkTranslation.is_synchronizing || props.bulkTranslation.prepare_word_count_pending || props.bulkTranslation.count_words_pending)) {
      setShowCard(true);
    }
  }, [props.bulkTranslation.is_synchronizing, props.bulkTranslation.prepare_word_count_pending, props.bulkTranslation.count_words_pending]);

  // Handle translation progress updates
  useEffect(() => {
    if (props.bulkTranslation.translate_progress !== translateProgress && !isTranslationComplete) {
      setTranslateProgress(props.bulkTranslation.translate_progress);
    }
    if (props.bulkTranslation.translate_words_pending !== translateWordsPending) {
      setTranslateWordsPending(props.bulkTranslation.translate_words_pending);
      // Reset auto-sync flag when a new translation starts
      if (props.bulkTranslation.translate_words_pending) {
        setHasAutoSynced(false);
      }
    }
    if (props.bulkTranslation.all_translate_jobs_count !== allTranslateJobsCount) {
      setAllTranslateJobsCount(props.bulkTranslation.all_translate_jobs_count);
    }
    if (props.bulkTranslation.all_translate_jobs_done !== allTranslateJobsDone) {
      setAllTranslateJobsDone(props.bulkTranslation.all_translate_jobs_done);
    }

    // Show card when translation is pending or completed
    if (!isCancelingRef.current && (props.bulkTranslation.translate_words_pending ||
        (props.bulkTranslation.translate_progress === 100 && !isSyncing))) {
      setShowCard(true);
    }

    // Derive sections to sync from completed translate tasks
    const sectionsToSync = getSectionsToSync(props.bulkTranslation.translate_tasks);

    // Automatically trigger synchronization when bulk translation completes
    if (
      !props.bulkTranslation.translate_words_pending &&
      props.bulkTranslation.translate_progress === 100 &&
      !isSyncing &&
      !hasAutoSynced &&
      sectionsToSync.length > 0
    ) {
      setHasAutoSynced(true);
      setPendingSyncs(sectionsToSync);
      pendingSyncsCountRef.current = sectionsToSync.length;
      handleSyncProcesses(sectionsToSync);
    }

  }, [
    props.bulkTranslation.all_translate_jobs_count,
    props.bulkTranslation.all_translate_jobs_done,
    props.bulkTranslation.translate_words_pending,
    props.bulkTranslation.translate_progress,
    props.bulkTranslation.translate_tasks,
    isTranslationComplete
  ]);

  // Latch isTranslationComplete once the success condition is first reached
  useEffect(() => {
    if (!translateWordsPending && translateProgress === 100 && !isSyncing) {
      setIsTranslationComplete(true);
    }
  }, [translateProgress, translateWordsPending, isSyncing]);

  // Hide card when tasks are explicitly canceled from any source (e.g. settings dialog)
  useEffect(() => {
    if (props.bulkTranslation.tasks_canceled) {
      isCancelingRef.current = true;
      clearInterval(window.tasksInterval);
      window.tasksInterval = null;
      window.tasksRequestPending = false;
      setShowCard(false);
      setTotalWordCount(0);
      setCountProgress(0);
      setHasCountTasks(false);
    }
  }, [props.bulkTranslation.tasks_canceled]);

  const handleSyncProcesses = async (sections) => {
    const sectionsToProcess = sections || pendingSyncs;

    setSyncTotal(sectionsToProcess.length);
    setSyncDone(0);

    for (const { scope, to } of sectionsToProcess) {
      await handleSync(scope, to);
    }
  };

  const handleSync = async (scope, to) => {
    const language = languages.find(x => x.code.toLowerCase() === to.toLowerCase());
    if (!language) {
      onSyncComplete(scope, to);
      return;
    }

    const languageId = language.id;
    const done = () => onSyncComplete(scope, to);
    setIsSyncing(true);

    switch (scope) {
      case 'products':
        props.syncProducts(languageId, true, done, {held: true});
        break;
      case 'collections':
        props.syncCollections(languageId, true, done, {held: true});
        break;
      case 'pages':
        props.syncPages(languageId, true, done, {held: true});
        break;
      case 'navigation':
        props.syncNavigation(languageId, done, {held: true});
        break;
      case 'blogs':
        props.syncBlogs(languageId, done, {held: true});
        break;
      case 'articles':
        props.syncArticles(languageId, true, done, {held: true});
        break;
      default:
        done();
        break;
    }
  };

  // Matched on scope AND language — the same scope can be pending for several languages.
  const onSyncComplete = (scope, to) => {
    pendingSyncsCountRef.current -= 1;
    setSyncDone(prev => prev + 1);

    setPendingSyncs(prev => {
      const remaining = prev.filter(s => !(s.scope === scope && s.to === to));

      // All syncs complete — use the ref count to avoid stale closure issues
      if (pendingSyncsCountRef.current <= 0) {
        setIsSyncing(false);

        // Refresh translation progress to update TranslationProgressSection
        props.getTranslationProgress(props.editLanguage, props.editTheme);
      }

      return remaining;
    });
  }

  // Load wordpack when not enough words
  const loadNextWordpack = (wordsNum) => {
    if (wordpack !== null) return;

    setWordpackLoading(true);

    // Round up to next 10,000
    const roundedWordsNum = Math.ceil(wordsNum / 10000) * 10000;
    // Create hash
    const hash = window.btoa(roundedWordsNum);

    API.bulkTranslationGetWordpack(hash, (res) => {
      setWordpackLoading(false);
      if (res.success === true) {
        setWordpack(res.data);
      } else {
        setWordpack(null);
      }
    });
  }

  // Determine current phase
  const isCountingPhase = (props.bulkTranslation.is_synchronizing || props.bulkTranslation.prepare_word_count_pending || props.bulkTranslation.count_words_pending || hasCountTasks) && !translateWordsPending && translateProgress < 100;
  const isReadyToTranslate = !props.bulkTranslation.count_words_pending && props.bulkTranslation.count_progress === 100 && props.bulkTranslation.total_words > 0 && props.bulkTranslation.total_words <= wordsLeft && !props.bulkTranslation.translate_words_pending;
  const needsMoreWords = !props.bulkTranslation.count_words_pending && props.bulkTranslation.count_progress === 100 && props.bulkTranslation.total_words > wordsLeft;
  const noWordsFound = !props.bulkTranslation.count_words_pending && props.bulkTranslation.count_progress === 100 && props.bulkTranslation.total_words === 0 && hasCountTasks;

  // Load wordpack when needsMoreWords becomes true
  useEffect(() => {
    if (needsMoreWords && totalWordCount > wordsLeft && wordpack === null && !wordpackLoading) {
      loadNextWordpack(totalWordCount - wordsLeft);
    }
  }, [needsMoreWords, totalWordCount, wordsLeft, wordpack, wordpackLoading]);

  return <div style={{position: 'fixed', bottom: 0, right: 24, width: 'auto', zIndex: 100000, pointerEvents: showCard ? 'auto' : 'none'}}>
    <Slide
      in={showCard}
      appear={false}
      direction="up"
      timeout={{
        enter: 1000,
        exit: isCancelingRef.current ? 900 : (translateWordsPending || countWordsPending) ? 1 : 900
      }}
      onExited={() => { isCancelingRef.current = false; }}
    >
      <Paper elevation={5} style={{padding: isMinimized ? '8px 12px 0 12px' : '12px', minWidth: Math.min(350, window.innerWidth - 24), maxWidth: 400, borderBottomLeftRadius: 0, borderBottomRightRadius: 0}}>
        <Typography variant="h5" gutterBottom sx={(isTranslationComplete && !isCountingPhase ? styles1.successText : null)} style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
          <span>
            <HorizontalSplitRoundedIcon style={{marginRight: 8}} /> {t('bulkTranslationFeature.statusDialog.title')}
          </span>
          <IconButton
            size="small"
            onClick={() => setIsMinimized(!isMinimized)}
            style={{marginTop: -4, marginRight: -8}}
          >
            {isMinimized ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        </Typography>
        <Divider style={{margin: '0 -12px'}} />
        {/* Show count progress or translate progress */}
        <LinearProgress
          variant="determinate"
          value={isCountingPhase ? countProgress : translateProgress}
          style={{position: 'absolute', width: '100%', marginTop: -4, left: 0}}
        />

        {/* Hide all content when minimized, only show header and progress bar */}
        {!isMinimized && (
          <>
            {/* COUNTING PHASE - Step 3 content */}
            {isCountingPhase && (
              <>
                {/* Counting in progress */}
                {(countWordsPending || props.bulkTranslation.is_synchronizing) && (
                  <>
                    <Fade in={props.bulkTranslation.is_synchronizing || countWordsPending} mountOnEnter unmountOnExit>
                      <Typography variant="body2" sx={styles2.text} style={{marginTop: 8, display: 'flex', alignItems: 'center'}}>
                        <CircularProgress size={16} style={{marginRight: 8, flexShrink: 0}} />
                        {props.bulkTranslation.is_synchronizing
                          ? synchronizingLabel(t, props.bulkTranslation)
                          : t('bulkTranslationFeature.settingsDialog.step3.countProgressInfo', {countProgress, totalWordCount: totalWordCount.toLocaleString()})
                        }
                      </Typography>
                    </Fade>
                  </>
                )}

                {/* No words found */}
                {noWordsFound && (
                  <>
                    <Typography variant="body2" style={{marginTop: 8}}>
                      {t('bulkTranslationFeature.settingsDialog.step3.foundNoWords')}
                    </Typography>
                  </>
                )}

                {/* Not enough words */}
                {needsMoreWords && (
                  <>
                    <Typography variant="body2" style={{marginTop: 8}}>
                      <Trans i18nKey={'bulkTranslationFeature.settingsDialog.step3.notEnoughWordsLeft'}
                        values={{
                          totalWordCount: new Intl.NumberFormat('en-US').format(totalWordCount),
                          missingWordCount: new Intl.NumberFormat('en-US').format(totalWordCount - wordsLeft)
                        }}
                      >
                        Your selection contains <strong>{new Intl.NumberFormat('en-US').format(totalWordCount)}</strong> words, but you don't have enough words left.
                      </Trans>
                    </Typography>
                  </>
                )}

                {/* Ready to translate - Step 4 content */}
                {isReadyToTranslate && (
                  <>
                    <Typography variant="body2" sx={styles2.text} style={{marginTop: 8}}>
                      {t('bulkTranslationFeature.settingsDialog.step4.successInfo')}
                    </Typography>
                    <Typography variant="body2" style={{marginTop: 4}}>
                      <Trans i18nKey={'bulkTranslationFeature.settingsDialog.step3.foundWords'} values={{totalWordCount: totalWordCount.toLocaleString()}}>
                        Found <strong>{totalWordCount.toLocaleString()}</strong> words to translate.
                      </Trans>
                    </Typography>
                  </>
                )}

                {/* Task errors */}
                {(props.bulkTranslation.task_errors.length > 0 && countProgress === 100) && (
                  <Typography variant="body2" sx={styles1.errorText} style={{marginTop: 8}}>
                    <Tooltip title={showTaskErrors ? t('bulkTranslationFeature.settingsDialog.hideAllErrors') : t('bulkTranslationFeature.settingsDialog.showAllErrors')} arrow>
                      <span onClick={(e) => {e.preventDefault(); setShowTaskErrors(!showTaskErrors);}} style={{cursor: 'pointer'}}>
                        {t('bulkTranslationFeature.settingsDialog.step3.taskErrors', {errorCount: props.bulkTranslation.task_errors.length})}
                      </span>
                    </Tooltip>
                    <Collapse in={showTaskErrors}>
                      {props.bulkTranslation.task_errors.map((item, index) => <Typography key={index}><small>{item}</small></Typography>)}
                    </Collapse>
                  </Typography>
                )}
              </>
            )}

            {/* TRANSLATION PHASE */}
            {!isCountingPhase && (
              <>
                {/* Show success message only after translation AND auto-sync complete */}
                {isTranslationComplete && (
                  <React.Fragment>
                    <Typography variant="body2" sx={styles2.successText} style={{marginTop: 8}}>
                      {t('bulkTranslationFeature.statusDialog.completedInfo', {scope: props.bulkTranslation.scope})} <DoneAllIcon style={{marginRight: 12}}/>
                    </Typography>
                  </React.Fragment>
                )}

                {/* Show synchronizing message while auto-sync is running */}
                <Fade in={!translateWordsPending && translateProgress === 100 && isSyncing} mountOnEnter unmountOnExit>
                  <Typography variant="body2" sx={styles2.text} style={{marginTop: 8, display: 'flex', alignItems: 'center'}}>
                    <CircularProgress size={16} style={{marginRight: 8, flexShrink: 0}} />
                    {synchronizingLabel(t, {sync_total: syncTotal, sync_done: syncDone, sync_phase: 'after'})}
                  </Typography>
                </Fade>

                {/* Show translation progress */}
                {translateWordsPending && (
                  <React.Fragment>
                    <Fade in={translateWordsPending} mountOnEnter unmountOnExit>
                      <Typography variant="body2" sx={styles2.text} style={{marginTop: 8, display: 'flex', alignItems: 'center'}}>
                        <CircularProgress size={16} style={{marginRight: 8, flexShrink: 0}} />
                        {t('bulkTranslationFeature.statusDialog.processRunning', {translateProgress})}
                      </Typography>
                    </Fade>
                    <Typography variant="body2">
                        {t('bulkTranslationFeature.statusDialog.fetchedTasks')} {(allTranslateJobsCount || 0).toLocaleString()} <br />
                        {t('bulkTranslationFeature.statusDialog.doneTasks')} {(allTranslateJobsDone || 0).toLocaleString()}
                    </Typography>
                  </React.Fragment>
                )}

                {/* Translation errors */}
                {(props.bulkTranslation.task_errors.length > 0) && (
                  <Typography variant="body2" sx={styles1.errorText}>
                    <Tooltip title={showTaskErrors ? t('bulkTranslationFeature.settingsDialog.hideAllErrors') : t('bulkTranslationFeature.settingsDialog.showAllErrors')} arrow>
                      <span onClick={(e) => {e.preventDefault(); setShowTaskErrors(!showTaskErrors);}} style={{cursor: 'pointer'}}>{props.bulkTranslation.task_errors.length} {t('bulkTranslationFeature.statusDialog.translationErrors')}</span>
                    </Tooltip>
                    <Collapse in={showTaskErrors}>
                      {props.bulkTranslation.task_errors.map((item, index) => <Typography key={index}><small>{item}</small></Typography>)}
                    </Collapse>
                  </Typography>
                )}
              </>
            )}
            <TasksList dense />
            <div style={{marginTop: 12, display: 'flex', gap: 8}}>
              {isTranslationComplete ? (
                <Button
                  variant="contained"
                  size="small"
                  style={{backgroundColor: '#4caf50', color: '#fff'}}
                  onClick={() => { setShowCard(false); setIsTranslationComplete(false); }}
                >
                  {t('bulkTranslationFeature.statusDialog.okay', 'Okay')}
                </Button>
              ) : (
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  disabled={props.location.pathname === '/machinetranslation/bulk'}
                  onClick={() => props.history.push('/machinetranslation/bulk')}
                >
                  {t('bulkTranslationFeature.statusDialog.goToBulk', 'Go to Bulk Translation')}
                </Button>
              )}
            </div>
          </>
        )}
      </Paper>
    </Slide>
  </div>
}

const styles1 = {
  badge: {
    color: 'accentSurface.text',
    backgroundColor: 'accentSurface.background',
    padding: '4px 8px',
    transform: 'scale(1) translate(100%, -25%)',
  },
  ctaBtn: {
    marginBottom: 12,
  },
  countWordsBtn: {
    //marginTop: 8,
  },
  loadingSign: {
    position: 'relative',
    margin: 4,
  },
  iconRight: {
    marginLeft: 12,
  },
  loadingSpinnerContainer: {
    margin: 'auto',
    top: 1,
    position: 'absolute',
    textAlign: 'center',
  },
  successText: (theme) => ({
    color: `${theme.palette.success.main} !important`,
  }),
  errorText: (theme) => ({
    color: `${theme.palette.error.main} !important`,
  }),
  /**
   * Die Wortstands-Texte waren auf rgba(0,0,0,0.87) festgenagelt — im Dark
   * Mode schwarz auf dunkler Karte. Das !important bleibt, es überschreibt
   * die Farbe der umgebenden Typography-Variante.
   */
  text: (theme) => ({
    color: `${theme.palette.text.primary} !important`,
  }),
  rotateIcon: {
    animation: 'spin 2s linear infinite',
    '@keyframes spin': {
      '0%': { transform: 'rotate(360deg)' },
      '100%': { transform: 'rotate(0deg)' },
    },
  },
};
 
const mapStateToProps1 = ({ shop, themes, stats, bulkTranslation, languages }) => ({
  shop: shop,
  themes: themes,
  languages: languages,
  stats: stats,
  editLanguage: shop.shop.edit_language,
  editTheme: themes.edit_theme,
  shopUrl: shop.shop.url,
  bulkTranslation: bulkTranslation,
});
const mapDispatchToProps1 = dispatch =>
  bindActionCreators(
    {
      bulkCountWords,
      bulkTranslationStart,
      bulkTranslationGetTasks,
      bulkTranslationClearTasks,
      resyncProducts,
      syncProducts,
      syncCollections,
      syncPages,
      syncNavigation,
      syncBlogs,
      syncArticles,
      bulkTranslationRewind,
      getTranslationProgress,
    },
    dispatch
  )
export const BulkTranslationStatusCard = withRouter(connect(
  mapStateToProps1,
  mapDispatchToProps1
)(BulkTranslationStatusCardComponent));